<template>
  <div v-if="can_show">


    <!-- {{ palmas_araucaria }}<br/><br/> -->
    <!-- data_chemin :{{data_chemin}} <br/><br/> -->
    <!-- dialog_gerar_parcela :{{dialog_gerar_parcela}} <br/><br/> -->
    <!-- obj_dados_empresa: {{ obj_dados_empresa }} <br/> -->
    <!-- obj_dados_cliente: {{ obj_dados_cliente }} <br/> -->

    <!-- modelo_impressao: {{modelo_impressao}} <br/> -->
    <!-- pro_dados_servico: {{pro_dados_servico}} <br/><br/> -->


    <!-- obj_recibo_unico : {{obj_recibo_unico}}  <br/> <br/> -->
    <!-- selecionou_varios : {{selecionou_varios}}  <br/> <br/> -->
    <!-- obj_clicado :{{ obj_clicado }} <br/> -->
    <!-- selected :{{ selected }} <br/> <br/> -->
    <!-- modal_items :{{ modal_items }} <br/> <br/> -->
    <!-- emp :{{ emp }} <br/> <br/> -->

    <!-- config_pix:{{ config_pix }} <br/><br/> -->

    <!-- config_emp:{{config_emp}} <br/><br/> -->

    <!-- souDSi:{{ souDSi }} <br/> <br/> -->
    <!-- podeFaturar:{{ podeFaturar }} <br/> <br/> -->

    <!-- item_menu: {{ item_menu }} <br/><br/> -->
    <!-- pro_dados_aluno:{{pro_dados_aluno}} <br/> <br/> -->
    <!-- pro_dados_servico:{{pro_dados_servico}} <br/> //aqui vem os dados de somatorias das parcelas tb -->

    <!-- {{items_tabela_formas}} -->
    <!-- edita_gerar_parcelas:{{edita_gerar_parcelas}} -->
    
    <!-- edita_parcelas:{{edita_parcelas}} <br/> -->

    <!-- <br/><br/>items_parcelas: {{items_parcelas}} -->
    <!-- {{ edita_copia }}<br><br> -->
    <!-- <br/><br/> {{ obj_valores }}  -->

    <!-- {{edita_parcelas}} -->
    <!-- {{obj_user}} -->
    
    <!-- <BR/> -->
    <!-- {{edita_parcelas}} -->
    <!-- {{ edita_gerar_parcelas }} -->
    <!-- item_menu: {{ item_menu }}  -->

<!-- <print_recibo_Vue
  v-if="print_recibo"
  :pro_dados_aluno   = 'pro_dados_aluno'
  :pro_dados_parcela = 'item_menu'
  :abrir = 'print_recibo'
  >
</print_recibo_Vue> -->
 


<v-row justify="center">
    <!-- IMPRIMIR RECIBO -->
    
    <v-dialog
      v-model="dialog_print"
      :fullscreen="true"
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!-- PAINEL TOPO AZUL BOTOES -->
      <v-card elevation="0">
        <v-toolbar
          dark
          color="primary"
          elevation="0"
          class="no-print"
        >


            <!-- <h3 class="pl-15 white--text">Carnê de Pagamento</h3> -->

            <v-spacer></v-spacer>


            <v-checkbox
                    v-model="meia_folha"
                    label="50%"
                    dense
                    class="pa-0 pr-10"
                    hide-details
                    
                >
            </v-checkbox>

            <v-btn
              @click="imprimir(item_menu)"
              color="primary text--white"
            >
              <v-icon color="white"> mdi-printer </v-icon>
              &nbsp imprimir
            </v-btn>


            <v-divider class="mx-2" vertical inset></v-divider>


            <v-btn
                
                color="primary"
                @click="close"
            >
                
                <v-icon>mdi-close</v-icon>
                &nbsp 
                Fechar
                
            </v-btn>

        </v-toolbar>


        <v-container fluid class="pa-2">
            <v-row dense>

                <!-- COLUNA ESQUERDA -->
                <v-card
                 class="no-print mt-1"
                 width="5%"
                 elevation="0"
                 height="100"
                >
                    <v-card class="mt-3 ml-2 grey lighten-4" v-if="0>1">
                        <v-row>
                            <v-col cols="3 offset-md-1">
 
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card>   


                <!-- COLUNA CENTRAL -->

                <v-row justify="center" class="" v-if="(modelo_impressao=='CARNE_FATURAS')">
                    <v-col cols="12 " md="8">

                        <h5 class="">Carnê de Faturas</h5>

                        <v-card >
                            
                        
                            <v-card
                            class="mx-auto"
                            outlined
                            >
                            <!-- max-width="344" -->


                            <v-row dense
                            v-for="(item, i) in modal_items"
                            :key="i"
                            class="mb-2"
                            >
                                <v-col class="" cols="8" >
                                    <v-card height="123px" class="">
                                        <v-list-item three-line>
                                            <v-list-item-content>
                                            
                                            <span class="fs-8 my-n1">{{i+1}}ª</span>
                                            
                                                <div class="text-overline mb-1">
                                                {{ emp.nome}}
                                            </div>
                                            <v-list-item-title class="text-h6 mb-1">
                                                {{ pro_dados_aluno.NOME}}
                                                <span class="fs-8 my-n1"> ({{ pro_dados_aluno.CODIGO_ALUNO }}) CPF: {{ pro_dados_aluno.CPF }} </span>
                                                
                                            </v-list-item-title>
                                            <v-list-item-subtitle class="fs-12">
                                                ({{ item.CODIGO}}) {{ item.SERVICO_REFERENTE }}
                                            </v-list-item-subtitle>
                                            </v-list-item-content>
                                    
                                            <!-- <v-list-item-avatar
                                            tile
                                            size="80"
                                            color="red"
                                            ></v-list-item-avatar> -->
                                            
                                        </v-list-item>
                                    </v-card>
                                </v-col>

                                <v-col class="" cols="2">
                                    <v-card class="d-flex flex-column align-center pt-3">
                                        
                                        
                                        <h5 class="ml-2 mb-1 fs-12"> 
                                            <!-- <span class="fs-8">{{i+1}}ª</span> -->
                                            {{item.PLANO}}
                                        </h5>

                                        <span class="ml-2 fs-12">VENCIMENTO</span>
                                        <v-chip small outlined class="ml-1">
                                            <!-- Vencimento:  -->
                                            <h4 class="ml-1">{{ item.x_DATA_VENCIMENTO}}</h4>
                                        </v-chip>

                                        
                                        
                                        <!-- <span class="ml-2 fs-12">VALOR</span> -->
                                        <v-chip small outlined class="ma-1 mt-2 mb-4">
                                            <!-- Valor: -->
                                            <h4 class="ml-1">{{ item.x_double_VALOR}}</h4>
                                        </v-chip>

                                        <!-- <v-chip small outlined class="ml-1 mb-1">
                                            <h4 class="ml-1">{{ item.SEQUENCIA}}</h4>
                                        </v-chip> -->
                                    </v-card>
                                </v-col>

                                <v-col class="" cols="2" >
                                    
                                    <!-- d-flex flex-column align-center -->
                                    <v-card class="pt-1">
                                        <img
                                        :src="gerarQRCode(item.PIX_URL)"
                                        height="105px" class="pa-0 mt-n1 "
                                    ></img>


                                    <!-- <v-chip small outlined class="ma-1 mt-n2 mb-1"> -->
                                    <div class="fs-8 mt-n4 ml-1 pa-0">
                                        PAGO:
                                    </div>   
                                    <div class="fs-10 mt-0 ml-2">
                                        _________ / _________
                                    </div>   
                                    <!-- </v-chip> -->

                                    <!-- <p><img src="https://dsi.app.br/qrcode/qrcode.php?s=qrl&d=https://www.asaas.com/i/6e1kn4exn7hw9bye"></p> -->

                                    </v-card>
                                </v-col>
                            </v-row>

                            </v-card>
                        </v-card>

                    </v-col>
                </v-row>

                <v-card class="sem_borda" v-if="(modelo_impressao=='RECIBO')">
                <!-- COLUNA CENTRAL -->
                    <!-- INICIO -->
                    <v-card
                    :height="(!meia_folha) ? '13cm' : '6.6cm'"
                    width="18.7cm"
                    class="grey lighten-4 ml-1"
                    :class="(!meia_folha && i==0) ? 'mb-15 mt-0' : 'mb-3'"
                    v-for="(item, i ) in objVias"
                    :key="i"
                    >
                    <!-- {{item}}  -->
                    <v-container fluid class="pa-2">
                        <v-row dense>

                            <v-card
                            width="13cm"
                            height="3.5cm"
                            class=" pt-0"
                            >
                                <center>
                                    <img
                                    ref="print_logo"
                                    :src="urlLogo"
                                    PATH_LOGO
                                    style="max-width: auto; height: 2.5cm"
                                    />
                                    <!-- src="http://localhost\vue_cfc\public\shalon.png" -->
                                </center>
                                <div 
                                class="ml-1"
                                style="margin-top: -0.3cm"
                                >
                                     <p class="inline h7">CNPJ: {{ emp.cnpj }}</p>
                                    &nbsp
                                    
                                    <p class="inline h7">FONES: {{ emp.fone1 }} | {{ emp.celular }} </p>
                                    &nbsp
                                    <p class="inline h7"> {{ emp.email }} </p>
                                </div>
                                
                                <div 
                                class="ml-1"
                                style="margin-top: -0.2cm"
                                >
                                    <p class="inline h7" > {{ emp.endereco }}</p>
                                </div>
                            </v-card>

                            <v-card
                            width="5.3cm"
                            height="3.5cm"
                            class=" px-2 ml-1"
                            elevation="2"
                            >

                            <h3 class="inline">RECIBO</h3> 
                            
                            <h6 class="inline pl-1" >
                                <!-- ({{item_menu.SEQUENCIA}}) -->
                                <!-- {{Object.keys(obj_recibo_unico).length}} -->
                                <!-- &nbsp {{  (Object.keys(obj_recibo_unico).length === 0) ? item_menu.CODIGO : 'ÚNICO'  }} -->
                                <!-- &nbsp {{  (Object.keys(obj_recibo_unico).length === 0) ? item_menu.CODIGO : obj_recibo_unico.NUMEROS  }} -->
                                 SEQ: {{ (item_menu.SEQUENCIA>0) ? item_menu.SEQUENCIA : obj_recibo_unico.SEQUENCIA }}
                            </h6> 

                            <div style="display: flex; justify-content: flex-end; margin-top:-25px; margin-bottom:2px">
                                <h6 class="inline">{{ i + 1}}ª Via</h6> 
                            </div>

                            <h6> {{  (Object.keys(obj_recibo_unico).length === 0) ? item_menu.CODIGO : obj_recibo_unico.NUMEROS  }}</h6> 
                            <!-- <h6 class="none">SEQ: {{ item_menu.SEQUENCIA || obj_recibo_unico.SEQUENCIA }}</h6> -->
                            

                            <h2 class="ml-1"> R$ 
                              <!-- {{  ((Object.keys(obj_recibo_unico).length === 0)) ? item_menu.double_TOTAL : obj_recibo_unico.TOTAL}}  -->
                                 {{valor_recibo}}
                            </h2>

                            <h5 class="none">Recebido em </h5>
                            <h4 class="inline ml-1">
                                 {{ ((Object.keys(obj_recibo_unico).length === 0)) ? getFormatDate(item_menu.DATA_EFETUADO) : obj_recibo_unico.DATA}} 
                            </h4>
                            
                            <!-- <h6 class="inline none">Venc. </h6>
                            <h5 class="inline"> 20/04/2022 </h5> -->
                            
                            </v-card>

                            <v-card
                            height="1cm"
                            width="15.4cm"
                            class=" mt-1 pa-1"
                            >
                            <!-- <p class="inline cap">Recebemos de  </p> -->
                            <h6 class="inline none">Recebemos de: </h6>
                            <h4 class="inline"> {{ pro_dados_aluno.NOME }} </h4>
                            <p class="inline cap"> &nbsp CPF:  </p>
                            <h5 class="inline"> {{ pro_dados_aluno.CPF }} </h5>
                            </v-card>

                            <v-card
                            height="1cm"
                            width="3cm"
                            class=" mt-1 pa-1"
                            >
                            <h6 class="none">PRO: {{ pro_dados_servico.PROCESSO }} </h6>
                            <h6 class="none">IDE: {{ pro_dados_aluno.CODIGO_ALUNO }}</h6>
                            </v-card>

                            <v-card
                            class=" mt-1 pa-1 "
                            :height="(!meia_folha)? '6.3cm' : '1.7cm'"
                            :width="(!meia_folha) ? '18.4cm' : '12.1cm'"
                            >
                            <h6 class=" none">Referente à: </h6>
                                <h6 class="inline none" v-if="(Object.keys(obj_recibo_unico).length === 0)">
                                    {{ item_menu.PLANO }}
                                    - V:{{ getFormatDate(item_menu.DATA_VENCIMENTO) }} 
                                    <!-- - R$ {{ (item_menu.double_TOTAL) }}  -->
                                     <!-- R$ {{valor_recibo}} -->
                                     {{(item_menu.x__double_JUROS > 0) ? `(${item_menu.double_VALOR} + ${item_menu.double_JUROS} de Juros = R$ ${valor_recibo})` : `R$ ${valor_recibo}`}}
                                    - {{ item_menu.FORMA_PAGAMENTO }}
                                    - {{ item_menu.SERVICO_REFERENTE }} 
                                    
                                    <!-- {{item_menu}} -->
                                </h6>
                                <h6 v-else class="none">
                                    <!-- recibo unico -->
                                    {{obj_recibo_unico.REFERENTE}} 
                                </h6>

                            </v-card>

                            <v-card
                            :height="(!meia_folha) ? '1.7cm' : '1.7cm'"
                            :width=" (!meia_folha) ? '18.4cm' :  '6.3cm'"
                            class=" mt-1 pa-1"
                            >
                            <!-- v-if="(!meia_folha)" -->
                            <center>
                                <h6 class="none pt-2">____________________________________________ </h6>
                                <h6 class="none"> 
                                    {{  ((Object.keys(obj_recibo_unico).length === 0)) ? item_menu.QUEM_EFETUOU : obj_recibo_unico.QUEM_EFETUOU}} 
                                </h6>

                                <h6 class="none pt-1"> {{ emp.cidade }}, {{ hoje }}</h6>
                            </center>
                            </v-card>

                        </v-row>
                    </v-container>
                    </v-card>
                </v-card>   

                <v-card class="sem_borda " v-if="(modelo_impressao=='CUPOM')">
                <!-- COLUNA CENTRAL -->
                    <!-- INICIO -->
                    <v-card
                    height="auto"
                    width="8.1cm"
                    class="grey lighten-4 ml-1 mb-3"
                    v-for="(item, i ) in objVias"
                    :key="i"
                    >
                    <!-- {{item}}  -->
                    <v-container fluid class="pa-2">
                        <v-row dense>

                            <v-card
                            width="8cm"
                            height="auto"
                            class="pt-1 "
                            >

                                <v-row>
                                    <v-col class=" pb-0">
                                        <center>
                                            <img
                                            ref="print_logo"
                                            :src="urlLogo"
                                            PATH_LOGO
                                            style="max-width: auto; height: 2.3cm"
                                            />
                                            <!-- src="http://localhost\vue_cfc\public\shalon.png" -->
                                        </center>
                                    </v-col>
                                </v-row>

                                <v-row class="my-0 px-1">
                                    <v-col class="fs-10 pb-0" cols="12">
                                        <span>CNPJ: {{ emp.cnpj }}</span>
                                        <span style="float: right;">FONE: {{ emp.fone1 }}</span>
                                    </v-col>

                                    <v-col cols="12 py-0 text-center">
                                        <h3 class="inline"> RECIBO</h3>
                                        <span class="fs-10 inline"> {{ item_menu.CODIGO }} </span>
                                    </v-col>
                                </v-row>

                                <v-row class="px-1 my-0 fs-10">
                                    <v-col>
                                        <span>Recebemos de </span>
                                        <h3 class="inline"> {{ item_menu.X_NOME }} </h3>
                                        <span>a quantia de  </span>
                                        <h3 class="inline"> {{ item_menu.x_double_TOTAL }} </h3>
                                        <span>em  </span>
                                        <h3 class="inline"> {{ item_menu.x_DATA_EFETUADO }} </h3>

                                        <div>
                                            <div class="inline">Forma de Pagamento:  </div>
                                            <h3 class="inline"> {{ item_menu.FORMA_PAGAMENTO }} </h3>
                                        </div>

                                        <div>
                                            <div class="inline">Referente:  </div>
                                            <h3 class="inline"> {{ item_menu.SERVICO_REFERENTE }} </h3>
                                        </div>

                                        <v-divider class="mx-0 my-1"></v-divider>

                                        <div class="mt-5">
                                            <div class="text-center">__________________________________  </div>
                                            <div class="text-center"> {{ item_menu.QUEM_EFETUOU }} </div>
                                        </div>

                                    </v-col>
                                </v-row>


                            </v-card>


                        </v-row>
                    </v-container>
                    </v-card>
                </v-card>   

                <v-spacer></v-spacer>
                <!-- COLUNA DIREITA -->
                <v-card
                 class="no-print mt-1"
                 width="300"
                 elevation="0"
                 height="100"
                 v-if="( ['CUPOM', 'RECIBO'].some(el => modelo_impressao.includes(el)) )"
                >

                    <v-card class="mt-3 ml-2 grey lighten-4">
                        <v-row>
                            <v-col cols="4 offset-md-1">
                                <!-- <v-card> -->
                                    <!-- <v-text-field
                                    v-model="nVias"
                                    label="Nº de Vias"
                                    type="number"
                                    @input="mudaVias(nVias)"
                                    ></v-text-field> -->

                                    <v-select
                                    v-model="nVias"
                                    :items="['1','2']"
                                    label="Nº de Vias"
                                    @input="mudaVias(nVias)"
                                    ></v-select>
                                <!-- </v-card> -->
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card> 

            </v-row>
        </v-container>
      </v-card>
    </v-dialog>
</v-row>


<v-overlay :value="overlay2">
    <v-progress-circular
        indeterminate
        size="64"
    ></v-progress-circular>
</v-overlay>


<v-dialog
    v-model="dialog_opcoes"
    max-width="699px"
    scrollable
>
  <v-card
    class="mx-auto"
  >
    <v-card-title class=" grey lighten-5">
      <h5>Definições</h5>

      <v-spacer></v-spacer>
      
      <v-icon
        color="red"
        @click="dialog_opcoes=!dialog_opcoes"
      >
        mdi-close
      </v-icon>

    </v-card-title>

    <v-card-text>
      <v-container class="mx-0 px-0 mt-2">
        <v-row>
          

            <v-col class="pb-0"
              cols="6" md="2"
              v-if="(tipo_definicao=='avaliacao_20')"
            >   
                <v-select v-model="opcao_categoria" label="Categoria"
                  :items="itens_categoria"
                  dense
                >
                </v-select>
            </v-col>

            <v-col class="pb-0"
              cols="6" md="2"
              v-if="(tipo_definicao=='avaliacao_20')"
            >   

                <v-select v-model="sel_num_aulas" label="Nº de Aulas"
                    :items="[
                        '2',        
                        '3',     
                        '4',     
                        '5',     
                        '6',     
                        '7',     
                        '8',
                        '9',
                        '10',
                        '11',
                        '12',     
                        '13',     
                        '14',     
                        '15',     
                        '16',     
                        '17',     
                        '18',  
                        '19',  
                        '20'  
                    ]"  
                  dense
                >
                </v-select>

               <!-- <v-text-field
                 v-model="sel_num_aulas"
                 label="Nº de Aulas"
                 type="text"
                 dense
               ></v-text-field> -->
            </v-col>

            <v-col class="pb-0"
              cols="6" md="2"
              v-if="(tipo_definicao=='avaliacao_20')"
            >   

                <v-select v-model="num_modelo" label="Modelo"
                    :items="[
                        '1',        
                        '2'
                    ]"  
                  dense
                >
                </v-select>

            </v-col>


          <v-col
            cols="12"
            md="10"
            class="ml-2"
            v-if="(tipo_definicao!=='avaliacao_20')"
          >      
            <v-text-field
              dense
              v-model="def.motivo_processo"
              label="Motivo do Processo"
              hide-details
              type="text"
              
            ></v-text-field>
          </v-col> 
          

          <v-col
            cols="12"
            md="1"
            class="ml-2"
            v-if="(tipo_definicao=='avaliacao_20')"
          >      
          <v-btn color="primary"
          @click="dialog_opcoes=!dialog_opcoes, clicou_menu_um('go_avaliacao_20')"
          >
            ok
          </v-btn>
          </v-col> 

          <v-col
            cols="12"
            md="1"
            class="ml-2"
            v-if="(tipo_definicao!=='avaliacao_20')"
          >      
          <v-btn color="primary"
          @click="dialog_opcoes=!dialog_opcoes"
          >
            ok
          </v-btn>
          </v-col> 
          

          
          <v-spacer></v-spacer>


        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</v-dialog>






<v-dialog
    v-model="dialog_menu"
    max-width="300px"
    scrollable
    class="no-print"
>
    <v-card class="mx-auto" v-if="(!selecionou_varios)">
        <v-list dense>

        <v-subheader class="grey lighten-5">
            <h3> {{ item_menu.CODIGO }} - R$ {{ item_menu.double_TOTAL }}</h3>
        </v-subheader>



        <v-divider
            class="mx-0"
        ></v-divider>



        <v-list-item
        link
        @click="editar_tabela(item_menu, 'edita_parcelas', 'dialog_alterar_parcela'), dialog_menu=false"
        v-if="(pode_alterar())"
        >
        <!-- v-if="(( obj_user.SUPER=='S' || item_menu.PAGO=='N') &&(pode_alterar()))" -->
        
            <v-list-item-icon>
            <v-icon color="primary">mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Alterar</v-list-item-title>
        </v-list-item>


        <v-divider
            class="mx-0"
        ></v-divider>



        <!-- IMPRIMIR RECIBO -->
        <v-list-item
        link
        @click="imprimir_recibo(item_menu,'RECIBO') ,dialog_menu=false "
        v-if="(item_menu.PAGO=='S')&&(pode_gerar()) &&(item_menu.TIPO=='E')"
        >
            <v-list-item-icon>
            <v-icon color="primary"> mdi-printer </v-icon>
            </v-list-item-icon>
            <v-list-item-title>Recibo</v-list-item-title>
        </v-list-item>


        <v-divider
            class="mx-0"
        ></v-divider>

        <!-- IMPRIMIR CUPOM -->
        <v-list-item
        link
        @click="imprimir_recibo(item_menu,'CUPOM') ,dialog_menu=false "
        v-if="(item_menu.PAGO=='S')&&(pode_gerar()) &&(item_menu.TIPO=='E')"
        >
            <v-list-item-icon>
            <v-icon color="primary"> mdi-printer-pos </v-icon>
            </v-list-item-icon>
            <v-list-item-title>Cupom</v-list-item-title>
        </v-list-item>


        <v-divider
            class="mx-0"
        ></v-divider>


        <v-list-item
        link
        @click="atualiza_juros(item_menu, true, true), dialog_menu=false"
        v-if="(0>1)"
        >
        <!-- v-if="((showJuros)&&(item_menu.PAGO=='N')&&(item_menu.TIPO=='E')&&(pode_alterar()))" -->
        <!-- v-if="item_menu.PAGO=='N'" -->
            <v-list-item-icon>
            <v-icon color="primary"> mdi-percent  </v-icon>
            </v-list-item-icon>
            <v-list-item-title>Calcular Juros</v-list-item-title>
        </v-list-item>


        <v-divider
            class="mx-0"
        ></v-divider>

        <span v-if="pode_alterar()">
            <v-list-item
            link
            @click="pre_gerar_pix(item_menu, true), dialog_menu=false"
            v-if="item_menu.PAGO !== 'S' && podeFaturar &&(item_menu.TIPO=='E') && (!item_menu.PIX_ID)"
            >
                <v-list-item-icon>
                <v-icon color="black">
                    mdi-barcode
                    <!-- mdi-qrcode-scan  -->
                </v-icon>
                </v-list-item-icon>
                <v-list-item-title>Gerar Fatura ({{config_emp.PIX_PLATAFORMA}})</v-list-item-title>
            </v-list-item>
        </span>

        <v-divider
            class="mx-0"
        ></v-divider>

        <v-list-item
        link
        @click="ver_cobranca_pix(item_menu), dialog_menu=false"
        v-if="item_menu.PIX_ID"
        >
            <v-list-item-icon>
            <v-icon color="primary">mdi-checkbook  </v-icon>
            </v-list-item-icon>
            <v-list-item-title>Ver Fatura</v-list-item-title>
        </v-list-item>


        <v-divider
            class="mx-0"
        ></v-divider>

        <v-list-item
        link
        @click="estornar(item_menu) ,dialog_menu=false "
        v-if="((item_menu.PAGO=='S') && (pode_estornar()))"
        :disabled="(item_menu.VISTO=='S')"
        >
            <v-list-item-icon>
            <v-icon color="red">mdi-currency-usd-off</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Estornar</v-list-item-title>
        </v-list-item>


        <!-- BOTAO EXCLUIR PARCELAS -->
        <v-divider
            class="mx-0 py-2"
        ></v-divider>

        <v-list-item
        link
        @click="remover_tabela('conta',item_menu, ''),dialog_menu=false,selected = []"
        v-if="((item_menu.PAGO=='N')&&(pode_excluir()))"
        >
            <v-list-item-icon>
            <v-icon color="red">
                mdi-close-thick
            </v-icon>
            </v-list-item-icon>
            <v-list-item-title>Excluir</v-list-item-title>
        </v-list-item>
        
        
        <!-- BOTAO EXCLUIR PARCELAS -->
        <v-divider
            class="mx-0 py-2"
        ></v-divider>

        <v-list-item
        link
        @click="excluir_todas_parcelas(item_menu) ,dialog_menu=false "
        v-if="(pode_excluir())"
        :disabled="(item_menu.VISTO=='S')"
        >
            <v-list-item-icon>
            <!-- <v-icon color="red">mdi-delete-circle-outline</v-icon> -->
            <v-icon color="red">mdi-close-box</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Excluir Todas Parcelas</v-list-item-title>
        </v-list-item>



        </v-list>
    </v-card>

    
    <v-card v-if="(selecionou_varios)">
        <v-list dense>
            <span v-for="(item, index) in menu_parcelas" :key="item.title+index" v-if="(item.type=='group')&&(vif_here(item.title))">

            <v-list-group
                v-model="(!selecionou_varios)  ? false : item.active"
                no-action
                @click.stop="" 
            >

            <!-- v-model="(item.title=='ÍTENS SELECIONADOS') ? fuba : item.active" -->
            <!-- {{['grupo'+'_'+index]}} -->

                <template v-slot:activator>

                <v-list-item-icon class="mr-1">
                    <v-icon :color="item.icon_color" small> {{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content >
                    <!-- <v-list-item-title v-text="item.title"></v-list-item-title> -->
                    <v-list-item-title>
                        <span v-if="item.title=='ESTE'">

                        <div class="white lighten-5 mx-0 mb-1">
                            <h4 v-if="item_menu.X_NOME_CLIENTE"> {{ item_menu.X_NOME_CLIENTE }} </h4>
                            <h4 v-if="item_menu.X_NOME_ALUNO"> {{ item_menu.X_NOME_ALUNO }} </h4>
                            <h4 v-if="(item_menu.CATEGORIA)&&(item_menu.TIPO == 'S')"> {{ item_menu.CATEGORIA }} </h4>
                            <h5> ({{ item_menu.CODIGO }}) - R$ {{ item_menu.double_TOTAL }}</h5>
                        </div>
                        </span>
                        <span v-else>
                        <!-- ÍTENS SELECIONADOS -->
                        {{ item.title }} &nbsp ({{ selected.length }})
                        </span>
                    </v-list-item-title>
                </v-list-item-content>
                </template>


                <v-divider class="blue mx-2"></v-divider>

                <span v-for="sub in item.items" :key="sub.title"   v-if="vif_here(sub.click)">

                <v-list-item
                link
                @click="clicou_menu_parcelas(sub.click)"
                class="px-12"
                >

                    <v-icon :color="sub.icon_color" >
                    {{ sub.icon }}
                    </v-icon>

                    <v-list-item-content class="ml-3">
                        <v-list-item-title v-text="sub.title"></v-list-item-title>
                    </v-list-item-content>

                </v-list-item>
                <v-divider class="mx-5"></v-divider>

            
                </span>

            </v-list-group>


            <v-divider class="blue mx-2 mt-2"></v-divider>
            </span>
        </v-list>
    </v-card>
    
</v-dialog>



<v-snackbar
    v-model="snackbar"
    :timeout="2000"
    top
    :color="snack_color"    
    style="margin-top: 30px"
>
<center>
    {{ snack_text }}
</center>
    <!-- <template v-slot:action="{ attrs }">
    <v-btn
        color="white"
        text
        v-bind="attrs"
        @click="snackbar = false"
    >
        Fechar
    </v-btn>
    </template> -->
</v-snackbar>





<v-row justify="center" class="no-print">
    <v-dialog
        v-model="dialog_gerar_parcela"
        persistent
        max-width="990px"
        scrollable
        
    >


    <v-overlay :value="overlay">
    <v-progress-circular
        indeterminate
        size="64"
    ></v-progress-circular>
</v-overlay>

        <v-form
            ref="form"
            v-model="valido2"
        >
            <v-card
            max-height="555px"
            scrollable
            >


            <!-- class="overflow-y-auto px-0 py-0" -->
            <v-card-title 
              :class="[(edita_gerar_parcelas.TIPO=='E') ? 'green lighten-4' : 'red lighten-4', 'mb-1']"
            >
                <span class="text-h5">Novo Lançamento </span>
                <span class="ml-2 text-h6">({{(edita_gerar_parcelas.TIPO=='E') ? 'Entrada' : 'Saida'}}) </span>

            </v-card-title>

            
            <v-card-subtitle class="grey lighten-4 pa-1 pl-3 pt-2">
                <v-container>


                    <v-row>
                        <v-col
                        cols="12"
                        md="12"
                        class=""
                        
                        v-if="primeira_parcela==false"
                        >
                        <!-- style="margin-top:-30px; margin-bottom:-10px" -->
                        <!-- <v-text-field
                            v-model="edita_gerar_parcelas.REFERENTE"
                            type=""
                            label="Referente"
                            dense
                            :rules="notnullRules"
                            required
                            @keyup="allUpper($event,'edita_gerar_parcelas', 'REFERENTE')"
                            @change="multiplica"
                        >
                        </v-text-field> -->
                            <!-- {{ combobox_servico }} -->
                            <v-combobox
                                v-model="combobox_servico"
                                label="Referente (digitação livre)"
                                :items="items_tabela_servico"
                                item-value='DESCRICAO'
                                item-text='DESCRICAO'
                                dense
                                :return-object ="true"
                                clearable
                                :rules="notnullRules"
                                @input="seleciona_servico(combobox_servico)" 
                                @keyup="digitou_servico"
                                @keyup.esc="combobox_servico='', digitou_servico"
                                
                            >
                            <!-- @keyup="allUpper($event,'edita_gerar_parcelas', 'REFERENTE')" -->

                            
                                <!-- <template slot='selection' slot-scope='{ item }'>
                                {{ item.DESCRICAO }}
                                </template> -->
            
                                <template slot='item' slot-scope='{ item }'>
                                    <h5>{{ item.DESCRICAO }}</h5>
                                    &nbsp | &nbsp
                                    <div 
                                    class="caption"
                                    >
                                    {{ item.double_TOTAL }}
                                    </div>    
                                    &nbsp | &nbsp
                                    <div 
                                    class="caption"
                                    >
                                    {{ item.NIVEL }}
                                    </div>                   
                                </template>
                            </v-combobox>

                        </v-col>
                    </v-row>
                    
                    <v-row class="">

                        <v-col
                            class=""
                            cols="12"
                            md="2"
                        >   
                        <!-- v-model="servico_selecionado" -->
                            <v-select
                            v-model="edita_gerar_parcelas.CODIGO_CONTA"
                            label="Conta Referente"
                            :items="items_tabela_contas"
                            item-value='CODIGO'
                            item-text='DESCRICAO'
                            return-object
                            dense
                            :clearable = "false"
                            >
                            
                            <template slot='selection' slot-scope='{ item }'>
                            {{ item.DESCRICAO }}
                            </template>
                            </v-select>
                        </v-col>

                        <v-col
                        cols="6"
                        md="3"
                        >

                            <!-- <v-select
                            v-model="edita_gerar_parcelas.FORMA"
                            label="Forma"
                            :items = "formas_pagamentos"
                            dense
                            @change="multiplica"
                            ></v-select> -->

                            <v-combobox
                            v-model="edita_gerar_parcelas.FORMA"
                            label="Forma"
                            :items="items_tabela_formas"
                            item-value='DESCRICAO'
                            item-text='DESCRICAO'
                            dense
                            :clearable = "false"
                            :return-object="false"
                            :search-input.sync="search_input_forma"
                            :rules="notnullRules"

                            @change="multiplica"
                            @input="apertou_enter($event), allUpper($event,'edita_gerar_parcelas', 'FORMA')" 
                            >
                        
                            
                                <template slot='selection' slot-scope='{ item }'>
                                    <span class="fs-12"> {{ item }}</span>
                                </template>

                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        Para adicionar na lista pressione <kbd>enter</kbd>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>

                            </v-combobox>

                        </v-col>


                        <v-col
                        cols="6"
                        md="2"
                        >
                            <v-text-field
                                v-model="edita_gerar_parcelas.DATA_VENCIMENTO"
                                type="date"
                                label="Vencimento"
                                dense
                                @change="multiplica"
                                hide-details="true"
                            >
                            </v-text-field>

                        </v-col>

                        <v-col
                        cols="6"
                        md="2"
                        >
                            <v-select
                                v-model="edita_gerar_parcelas.EFETUAR"
                                type="number"
                                label="Efetuado"
                                :items="lista_efetuar"
                                dense
                                @change="multiplica"
                                hide-details="true"
                            >
                            </v-select>

                                <div v-if="(showJuros)" class="mt-0 pt-1">
                                    <v-checkbox
                                            v-model="edita_gerar_parcelas.COBRAR_JUROS"
                                            label="JUROS"
                                            dense
                                            style="margin-left: -4px"
                                            class="pa-0"
                                            hide-details="true"
                                            true-value="1"
                                            false-value="0"
                                        >
                                        <template v-slot:label>
                                          <span class="blue--text ml-n2" style="font-size:12px !important">Cobrar Juros</span>
                                        </template>
                                    </v-checkbox>
                                  </div>

                        </v-col>


                        <v-col
                        cols="6"
                        md="2"
                        >
                        <v-text-field
                            v-model="edita_gerar_parcelas.TOTAL"
                            type=""
                            label="Total"
                            prefix="R$"
                            dense
                            @keyup="edita_gerar_parcelas.TOTAL = moeda($event)"
                            @change="multiplica"
                            :rules="notnullRules"
                            hide-details="true"
                        >
                        <!-- @keyup="edita_gerar_parcelas.TOTAL = this.DSibasico.moeda($event)" -->
                        <!-- @keyup="edita_servico.double_TOTAL = moeda($event)" -->
                        </v-text-field>

                        <div class="" v-if="(primeira_parcela) && (edita_gerar_parcelas.TIPO=='E')">
                            <v-checkbox
                                v-model="checkbox_entrada"
                                label="com entrada"
                                dense
                                class=""
                                style="margin-left: -4px"
                                @change="multiplica"    
                            ></v-checkbox>
                        </div>


                        </v-col>



                        <v-col
                        cols="6"
                        md="1"
                        >

                            <v-select
                                v-model="edita_gerar_parcelas.PARCELAS"
                                type="number"
                                label="Parcelas"
                                :items="lista_parcelas"
                                dense
                                hide-details="true"
                            >
                            </v-select>

                            <div class="">
                                <v-checkbox
                                    v-model="multi"
                                    label="x"
                                    dense
                                    class=""
                                    style="margin-left: -4px"
                                    @change="multiplica"    
                                    hint="Multiplica"
                                ></v-checkbox>
                            </div>
                        </v-col>
                    </v-row>



                </v-container>
            </v-card-subtitle>

<!-- {{ def_parcelas }} -->
            <v-card-text class="pa-0 pl-0">
                    <v-card-text>
                        <v-container>
                            <v-row class="" dense
                            v-for="(item, i) in def_parcelas"
                            :key="i"
                            >
                            <!-- {{ def_parcelas }} -->
                            <!-- {{ item }}                      -->
                            <!-- {{edita_parcelas}} -->

                                <span 
                                    class="blue--text mt-3"
                                    v-if="checkbox_entrada && i==0"
                                >
                                    en 
                                </span>   
                                <span 
                                    class="mt-3"
                                    v-else
                                >
                                    {{ 1-inicio + parseInt(i)}}ª 
                                </span>   

                                <v-col
                                cols="6"
                                md="2"
                                >
                                    <v-text-field
                                        v-model="item.TOTAL"
                                        type=""
                                        :label="(checkbox_entrada && i==0) ? 'Entrada' : 'Valor'"
                                        prefix="R$"
                                        dense
                                        @keyup="item.TOTAL = moeda($event), digitou_entrada(item)"
                                        @change="multiplica()"
                                        :disabled="def_parcelas.length==i+ parseInt(1)"    
                                    >
                                    <!-- :disabled="def_parcelas.length==i+ parseInt(1)" desabilita quando ultimo campo -->

                                    </v-text-field>
                                </v-col>

                                &nbsp
                                &nbsp


                                <v-col
                                cols="6"
                                md="2"
                                >

                                    <!-- <v-select
                                    v-model="item.FORMA"
                                    label="Formax"
                                    :items = "formas_pagamentos"
                                    dense
                                    ></v-select> -->

                                    <v-select
                                    v-model="item.FORMA"
                                    label="Forma..."
                                    :items="items_tabela_formas"
                                    item-value='DESCRICAO'
                                    item-text='DESCRICAO'
                                    :return-object="false"
                                    dense
                                    :clearable = "false"
                                    @change="seleciona_forma_pagamento()"
                                    >
                                    
                                    <template slot='selection' slot-scope='{ item }'>
                                        <span class="fs-12"> {{ (item.DESCRICAO)? item.DESCRICAO : item }}</span>
                                    </template>
                                    </v-select>

                                </v-col>

                                &nbsp
                                &nbsp

                                <v-col
                                cols="6"
                                md="2"
                                >
                                <v-text-field
                                    v-model="item.DATA_VENCIMENTO"
                                    type="date"
                                    label="Vencimento"
                                    dense
                                >
                                </v-text-field>
                                </v-col>

                                &nbsp
                                &nbsp

                                <v-col
                                cols="6"
                                md="2"
                                >
                                <v-text-field
                                    v-model="item.DATA_EFETUADO"
                                    type="date"
                                    label="Efetuado"
                                    dense
                                >
                                </v-text-field>
                                </v-col>

                                &nbsp
                                &nbsp


                                <v-col
                                cols="3"
                                >
                                <v-text-field
                                    v-model="item.SERVICO_REFERENTE"
                                    type=""
                                    label="Referente."
                                    dense
                                    class="fs-12"
                                    :rules="notnullRules"
                                    @keyup="item.SERVICO_REFERENTE=item.SERVICO_REFERENTE.toUpperCase()"
                                >
                                </v-text-field>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card-text>
            </v-card-text>
            <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn
                    color="red"
                    text
                    @click="dialog_gerar_parcela=false"
                >
                    Cancelar
                </v-btn>
                
                
                &nbsp

                <v-btn
                    :disabled="!valido2"
                    color="primary"
                    @click="gerar_parcelas()"
                >
                    Gerar.
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</v-row>


<v-row justify="center" class="no-print">
    <v-dialog
        v-model="dialog_alterar_parcela"
        persistent
        max-width="990px"
        scrollable
        
    >

        <v-card
        max-height="555px"
        scrollable
        >
        <!-- class="overflow-y-auto px-0 py-0" -->
            <v-card-title 
            :class="[(edita_parcelas.TIPO=='E') ? 'green lighten-4' : 'red lighten-4', 'mb-1']"
            >
                <span class="text-h5">Alterar Parcela</span> 
                &nbsp <span class="text-caption"> {{ edita_parcelas.CODIGO  }} </span>
            </v-card-title>

            <v-form
            v-model="valido"
            >
            
            
                <v-card-text class="">
                    <v-container>
                        <v-row >

                            <v-col
                                class=""
                                cols="12"
                                :md="(showJuros) ? 3: 3"
                            >   
                            <!-- v-model="servico_selecionado" -->
                                <v-select
                                v-model="edita_parcelas.CODIGO_CONTA"
                                label="Conta Referente"
                                :items="items_tabela_contas"
                                item-value='CODIGO'
                                item-text='DESCRICAO'
                                return-object
                                dense
                                :clearable = "false"
                                @change="seleciona_conta_referente()"
                                :disabled="(edita_parcelas.PAGO=='S')&&(0>1)"
                                >
                                <!-- :label="edita_parcelas.CODIGO_CONTA.DESCRICAO" -->
                                
                                <template slot='selection' slot-scope='{ item }'>
                                {{ item.DESCRICAO }}
                                </template>
                                </v-select>
                            </v-col>

                            

                            <v-col
                            cols="6"
                            md="2"
                            >
                                <v-text-field
                                    v-model="edita_parcelas.double_VALOR"
                                    label="Valor"
                                    prefix="R$"
                                    dense
                                    :rules="notnullRules"    
                                    @keyup="edita_parcelas.double_VALOR = moeda($event), calcula()"
                                    :disabled="(edita_parcelas.PAGO=='S')&&(obj_user.SUPER!='S')&&(0>1)"
                                    hide-details="true"
                                >
                                
                                </v-text-field>

                                    <div v-if="(showJuros)" class="mt-0">
                                        <v-checkbox
                                                v-model="check_juros_aqui"
                                                label="TAXAS"
                                                dense
                                                style="margin-left: -4px"
                                                class="pa-0"
                                                hide-details="true"
                                                @click="clicou_em('CHECK_JUROS_AQUI', check_juros_aqui)"
                                            >
                                            <template v-slot:label>
                                            <span class="pink--text ml-n2" style="font-size:12px !important">Taxas</span>
                                            </template>
                                        </v-checkbox>
                                    </div>

                            </v-col>


                            
                            <v-col
                            cols="6"
                            md="2"
                            v-if="(showJuros)"
                            >
                                <v-text-field
                                    v-model="edita_parcelas.double_JUROS"
                                    label="+ Juros"
                                    prefix="R$"
                                    dense
                                    hide-details=""
                                    @keyup="edita_parcelas.double_JUROS = moeda($event), calcula()"
                                    :disabled="(edita_parcelas.PAGO=='S')&&(0>1)"
                                >
                                     <template v-slot:label>
                                        <span class="red--text">  + Juros</span>
                                    </template>

                                </v-text-field>

                                <div v-if="(showJuros)" class="mt-0 ">
                                    <v-checkbox
                                            v-model="edita_parcelas.COBRAR_JUROS"
                                            label="JUROS"
                                            dense
                                            style="margin-left: -4px"
                                            class="pa-0"
                                            hide-details="true"
                                            true-value="0"
                                            false-value="1"
                                            :disabled="(edita_parcelas.PAGO=='S')&&(0>1)"
                                        >
                                        <template v-slot:label>
                                          <span class="blue--text ml-n2" style="font-size:12px !important">Juros Manual</span>
                                        </template>
                                    </v-checkbox>

                                  </div>

                            </v-col>

                            <v-col
                            cols="6"
                            md="2"
                            v-if="(showJuros) && (check_juros_aqui)"
                            >
                                <v-text-field
                                    v-model="edita_parcelas.double_TAXA"
                                    label="- Taxa"
                                    prefix="R$"
                                    dense   
                                    @keyup="edita_parcelas.double_TAXA = moeda($event), calcula()"
                                    :disabled="(edita_parcelas.PAGO=='S')&&(0>1)"
                                >

                                   <template v-slot:label>
                                        <span class="pink--text">  - Taxa</span>
                                    </template>
                                
                                </v-text-field>
                            </v-col>

                            <v-col
                            cols="6"
                            md="2"
                            v-if="(showJuros)"
                            >
                                <v-text-field
                                    v-model="edita_parcelas.double_TOTAL"
                                    label="Total"
                                    prefix="R$"
                                    dense
                                    :rules="notnullRules"    
                                    @keyup="edita_parcelas.double_TOTAL = moeda($event)"
                                    disabled
                                >
                                <!-- :disabled="(edita_parcelas.PAGO=='S')&&(obj_user.SUPER!='S')" -->
                                </v-text-field>
                            </v-col>


                            <v-col
                            cols="6"
                            md="3"
                            >

                                <!-- <v-select
                                v-model="edita_parcelas.FORMA_PAGAMENTO"
                                label="Forma"
                                :items = "formas_pagamentos"
                                dense
                                ></v-select> -->

                                <v-combobox
                                    v-model="edita_parcelas.FORMA_PAGAMENTO"
                                    label="Forma."
                                    :items="items_tabela_formas"
                                    item-value='DESCRICAO'
                                    item-text='DESCRICAO'
                                    :return-object="false"
                                    dense
                                    
                                    :search-input.sync="search_input_forma"
                                    @input="apertou_enter($event), allUpper($event,'edita_parcelas', 'FORMA_PAGAMENTO')" 
                                    :rules="notnullRules"
                                    :clearable = "false"

                                    @change="seleciona_forma_pagamento()"
                                    >
                                    
                                    <template slot='selection' slot-scope='{ item }'>
                                        <span class="fs-12"> {{ (item.DESCRICAO)? item.DESCRICAO : item }}</span>
                                    </template>

                                    <template v-slot:no-data>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <v-list-item-title>
                                            Para adicionar na lista pressione <kbd>enter</kbd>
                                        </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </template>

                                </v-combobox>

                            </v-col>


                            <v-col
                            cols="6"
                            md="2"
                            >
                            <v-text-field
                                v-model="edita_parcelas.DATA_VENCIMENTO"
                                type="date"
                                label="Vencimento"
                                dense
                                :disabled="(edita_parcelas.PAGO=='S')&&(0>1)"
                            >
                            </v-text-field>
                            </v-col>



                            <v-col class=""
                            cols="6"
                            md="2"
                            v-if="0>1"
                            >
                              <v-text-field
                                  v-if="(edita_parcelas.PAGO=='S')"
                                  v-model="edita_parcelas.DATA_EFETUADO"
                                  type="date"
                                  label="Efetuado"
                                  dense
                              >
                              </v-text-field>

                              <div :class="(edita_parcelas.PAGO=='S')? 'mt-n4' : 'mt-2'">
                                <v-checkbox
                                    v-model="checkbox_efetuado"
                                    label="EFETUADO"
                                    dense
                                    style="margin-left: -4px"
                                    @click="muda_pago(checkbox_efetuado)"
                                    class="pa-0"
                                    hide-details="true"
                                >
                                    <template v-slot:label>
                                      <span :class="[(edita_parcelas.PAGO=='S') ? 'fs-12': '', 'blue--text']">EFETUADO</span>
                                    </template>
                                </v-checkbox>
                              </div>

                            </v-col>


                            <v-col
                            cols="6"
                            md="2"
                            v-if="(edita_parcelas.PAGO=='S')"
                            >
                            <v-text-field
                                v-model="edita_parcelas.DATA_EFETUADO"
                                type="date"
                                label="Efetuado"
                                dense
                                :disabled="(edita_parcelas.PAGO=='S')&&(obj_user.SUPER!='S')&&(0>1)"
                            >
                            </v-text-field>
                            </v-col>


                            <v-col
                            cols="12"
                            :md="(showJuros) ?  (edita_parcelas.PAGO=='S')? 8 : 10 : 10"
                            
                            >
                            <v-text-field
                                v-model="edita_parcelas.SERVICO_REFERENTE"
                                type=""
                                label="Referente"
                                dense
                                :rules="notnullRules"
                                @input="allUpper($event,'edita_parcelas', 'SERVICO_REFERENTE')"
                                :disabled="(edita_parcelas.PAGO=='S')&&(0>1)"
                            >
                            </v-text-field>

                            </v-col>

                        </v-row>

                        
 
                            

                            <v-row>
                            <v-col
                            dense
                            cols="12"
                            :md="(showJuros) ? 12: 10"
                            class=""
                            v-if="(2>1)"
                            >
                                <v-text-field
                                    v-model="edita_parcelas.OBSERVACAO"
                                    type=""
                                    label="Anotação / Pix Titular /..."
                                    dense
                                    @keydown="firstUpper($event, edita_parcelas.OBSERVACAO)"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

            </v-form>

            <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn
                    color="red"
                    text
                    @click="dialog_alterar_parcela=false"
                >
                    Cancelar
                </v-btn>
                
                
                &nbsp

                <v-btn
                    :disabled="!valido"
                    color="primary"
                    type="submit"
                    @click="salvar_calculando()"
                >
                <!-- @click="salvar_tabela('conta', edita_parcelas,'dialog_alterar_parcela')" -->
                    Salvar
                    <!-- SALVAR PARCELA -->
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-row>


<v-row justify="center" class="no-print">
    <v-dialog
        v-model="dialog_efetuar"
        persistent
        max-width="1024px"
        scrollable
        
    >

        <v-card
        max-height="555px"
        scrollable
        >
        <!-- class="overflow-y-auto px-0 py-0" -->
            <v-card-title class="grey lighten-4">
                <span class="text-h5">Receber Parcela</span> 
                &nbsp <span class="text-caption"> {{ edita_parcelas.CODIGO  }} ({{ edita_parcelas.PLANO }})</span>
                <!-- {{ total_recebido }} -->
            </v-card-title>

            <!-- {{ edita_parcelas }}
            <br/>
            <br/>
            <br/>
            {{ total_recebido }} -->
            <v-form
            v-model="valido3"
            >
            
            
                <v-card-text class="">
                    <v-container>
                        <v-row dense>

                            <v-col
                                class=""
                                cols="12"
                                md="2"
                            >   
                            <!-- v-model="servico_selecionado" -->
                                <v-select
                                v-model="edita_parcelas.CODIGO_CONTA"
                                label="Conta Referente"
                                :items="items_tabela_contas"
                                item-value='CODIGO'
                                item-text='DESCRICAO'
                                return-object
                                class="fs-12"
                                dense
                                :clearable = "false"
                                @change="seleciona_conta_referente()"
                                >
                                <!-- :label="edita_parcelas.CODIGO_CONTA.DESCRICAO" -->
                                
                                <template slot='selection' slot-scope='{ item }'>
                                {{ item.DESCRICAO }}
                                </template>
                                </v-select>
                            </v-col>



                            <v-col
                            cols="12"
                            md="2"
                            >
                            <!-- :md="(checkbox_parcial) ? '2' : '3' " -->

                                <!-- <v-select
                                v-model="edita_parcelas.FORMA_PAGAMENTO"
                                label="Forma"
                                :items = "formas_pagamentos"
                                dense
                                ></v-select> -->

                                <!-- se precisar..mudar o componente para combobox -->
                                <v-combobox
                                    v-model="edita_parcelas.FORMA_PAGAMENTO"
                                    label="Forma.."
                                    :items="items_tabela_formas"
                                    item-value='DESCRICAO'
                                    item-text='DESCRICAO'
                                    :return-object="false"
                                    dense

                                    :search-input.sync="search_input_forma"
                                    @input="apertou_enter($event), allUpper($event,'edita_parcelas', 'FORMA_PAGAMENTO')" 
                                    :rules="notnullRules"
                                    :clearable = "false"
                                    @change="seleciona_forma_pagamento()"
                                    >
                                    
                                    <template slot='selection' slot-scope='{ item }'>
                                        <span class="fs-11"> {{ (item.DESCRICAO)? item.DESCRICAO : item }}</span>
                                    </template>

                                    <template v-slot:no-data>
                                    <v-list-item>
                                        <v-list-item-content>
                                        <v-list-item-title>
                                            Para adicionar na lista pressione <kbd>enter</kbd>
                                        </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    </template>

                                </v-combobox>
                                    
                            </v-col>


                            &nbsp
                            &nbsp

                            <v-col
                            cols="12"
                            md="2"
                            >
                            <v-text-field
                                v-model="edita_parcelas.DATA_EFETUADO"
                                type="date"
                                label="Efetuado"
                                dense
                                :rules="notnullRules"    
                            >

                            <!-- <template slot='item' slot-scope='{ item }'>
                                <span class="fs-8"> {{ item }}</span>
                            </template> -->

                            </v-text-field>
                            </v-col>

                            &nbsp
                            &nbsp
                            
                            <v-col
                            cols="6"
                            md="2"
                            class=""
                            style="margin-top: -12px"
                            >
                                <h3>
                                Total
                                </h3>    
                                <h3>
                                    {{ edita_parcelas.double_TOTAL }}    
                                </h3>  
                            </v-col>


                            <v-col
                            cols="auto"
                            class=""
                            style="margin-top: 2px"
                            >

                                <v-checkbox
                                    v-model="checkbox_juros"
                                    label="Juros?"
                                    dense
                                    style="margin-left: -70px"
                                    class="mt-n6"   
                                    v-if="(strtofloat(edita_parcelas.double_JUROS)>0) && (pode_alterar())"
                                    @change="cobrar_juros()"
                                ></v-checkbox>


                                <v-checkbox
                                    v-model="checkbox_parcial"
                                    label="Parcial"
                                    dense
                                    style="margin-left: -70px"
                                    @click="mesmo_valor"
                                    :class="[(strtofloat(edita_parcelas.double_JUROS)>0) && (pode_alterar()) ? 'mt-n4':'']"
                                >
                                    <template v-slot:label>
                                    <span class="orange--text">Parcial</span>
                                    </template>
                                </v-checkbox>

                            </v-col>




                            &nbsp
                            &nbsp
                            



                            <v-col
                            cols="12"
                            md="2"
                            class=""
                            v-if="checkbox_parcial"
                            >
                                <v-text-field
                                    v-model="total_recebido"
                                    label="Valor Recebido"
                                    prefix="R$"
                                    dense
                                    :rules="acimaZero"    
                                    @keyup="total_recebido = moeda($event)"
                                >
                                
                                </v-text-field>
                            </v-col>

    &nbsp
    &nbsp

                            <v-col
                            cols="12"
                            md="1"
                            class=""
                            v-if="checkbox_parcial"
                            >
                                <v-text-field
                                    v-model="prorrogar_parcial"
                                    type="number"
                                    label="Restante em"
                                    suffix="dias"
                                    dense
                                    :rules="ate45"    
                                >
                                
                                </v-text-field>
                            </v-col>

                        </v-row>



                    <v-row
                    class=""
                    >

                            <!-- <v-col
                            cols="auto"
                            md="auto offset-md-7"
                            class="pa-0"
                            style="margin-top:-35px; margin-bottom:-10px"
                            >
                                <v-checkbox
                                    v-model="checkbox_entrada"
                                    label="parcial"
                                    dense
                                    class=""
                                    style="margin-left: 20px"  
                                ></v-checkbox>
                                
                            </v-col> -->


                    </v-row>

                        <v-row dense>
                            <v-col
                            md="12"
                            class="pr-6"
                            >
                                <v-text-field
                                    v-model="edita_parcelas.SERVICO_REFERENTE"
                                    type=""
                                    label="Referentee"
                                    dense
                                    :rules="notnullRules"
                                    @input="allUpper($event,'edita_parcelas', 'SERVICO_REFERENTE')"
                                >
                                </v-text-field>
                            </v-col>


                            <v-col
                            dense
                            cols="12"
                            md="12"
                            class="pr-6"
                            v-if="(2>1)"
                            >
                                <v-text-field
                                    v-model="edita_parcelas.OBSERVACAO"
                                    type=""
                                    label="Anotação"
                                    dense
                                    @keydown="firstUpper($event, edita_parcelas.OBSERVACAO)"
                                >
                                </v-text-field>
                            </v-col>

                        </v-row>





                    </v-container>
                </v-card-text>

            </v-form>

            <v-card-actions>
                <v-spacer></v-spacer>


                <v-checkbox
                    v-model="checkbox_recibo"
                    label=""
                    dense
                    class="px-0 mr-2 pb-2"
                    style="margin-left: 8px" 
                    prepend-icon="mdi-printer"
                    hide-details=""
                ></v-checkbox>
                
                <v-divider vertical class="px-0 mr-2"/>

                 <v-btn
                    color="red"
                    text
                    @click="dialog_efetuar=false"
                >
                    Cancelar
                </v-btn>
                




                &nbsp
                &nbsp

                <v-btn
                    :disabled="!valido3"
                    color="primary"
                    type="submit"
                    @click="efetuar()"
                >
                    Efetuar.
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</v-row>

    <!-- PAINEL PARCELAS PROCURAR -->
    <v-container class="pl-0 pt-2 pb-0 pr-0 no-print">
        <v-card
        class="pl-0"
        >

        <!-- DSI -->
        <!-- pro_dados_aluno: {{pro_dados_aluno}}
        <br/>
        pro_dados_servico : {{ pro_dados_servico }} -->

        <v-card-title class="pa-0 pb-2 grey lighten-5">


            <span 
             v-if="((permissoes.gerarparcelas) && (pode_gerar()))"
            >
                <v-tooltip 
                bottom
                >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    class="ml-2 mt-1"
                    @click="mais_parcelas('E')"
                    x-small
                    color="success"
                    >
                    <!-- v-show="!hidden" -->
                    <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span> Nova Entrada</span>
                </v-tooltip>
            </span>

            <span 
             v-if="((permissoes.gerarparcelas) && (pode_gerar()))"
            >
                <v-tooltip 
                bottom
                >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    class="ml-4 mt-1"
                    @click="mais_parcelas('S')"
                    x-small
                    color="error"
                    >
                    <!-- v-show="!hidden" -->
                    <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span> Nova Saida </span>
                </v-tooltip>
            </span>

            <span>
                <v-tooltip 
                bottom
                >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    class="ml-4 mt-1"
                    @click="tabela('conta','update')"
                    x-small
                    color="primary"
                    >
                    <!-- v-show="!hidden" -->
                    <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
                <span> Atualizar </span>
                </v-tooltip>
            </span>



            &nbsp


            <v-menu
                offset-y
                bottom
                right
                min-width="180"
                v-if="(pode_imprimir())"
            >
             <!-- && mostrar_tipo_cliente('CFC') -->
                <template v-slot:activator="{ on: menu }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                                class="ml-2 mt-1"
                                color="primary"
                                small

                                fab
                                v-on="{ ...tooltip, ...menu }"
                            >
                                <v-icon class="">
                                mdi-printer 
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Imprimir ...</span>
                    </v-tooltip>
                </template>


              <v-card
                class="mx-auto"
              >

                <v-list dense>

                    <!-- <v-subheader class="grey lighten-3">
                      <h4 class="ml-1"> Menu </h4>
                    </v-subheader> -->


                    <v-list-item
                         v-for="item in menu_um"
                         :key="item.title"
                         link
                         @click="clicou_menu_um(item.click)"
                         v-if="item.type=='menu'"
                        >

                        <v-list-item-icon>
                            <v-icon :color="item.icon_color"> {{ item.icon }}</v-icon>
                          </v-list-item-icon>

                          <v-list-item-content>
                              <v-list-item-title v-text="item.title"></v-list-item-title>
                          </v-list-item-content>

                    </v-list-item>



                    <v-list-group
                        v-for="item in menu_um"
                        :key="item.title"
                        v-model="item.active"
                        
                        no-action
                        @click.stop="" 
                        v-if="(item.type=='group')"
                    >

                        <template v-slot:activator>

                          <v-list-item-icon>
                            <v-icon :color="item.icon_color"> {{ item.icon }}</v-icon>
                          </v-list-item-icon>

                          <v-list-item-content>
                              <v-list-item-title v-text="item.title"></v-list-item-title>
                          </v-list-item-content>
                        </template>


                        <v-list-item
                         v-for="sub in item.items"
                         :key="sub.title"
                         link
                         @click="clicou_menu_um(sub.click)"
                        >

                          <v-list-item-content>
                              <v-list-item-title v-text="sub.title"></v-list-item-title>
                          </v-list-item-content>
                          
                          
                          <v-list-item-icon>
                            <v-icon :color="sub.icon_color"> {{ sub.icon }}</v-icon>
                          </v-list-item-icon>

                        </v-list-item>
                    </v-list-group>



                </v-list>
              </v-card>
            </v-menu>


            <v-col cols="auto">

            <v-tooltip bottom eager>
                <template v-slot:activator="{ on, attrs }">
                    <v-checkbox
                    v-model="checkbox_so_entradas"
                    dense
                    class="ma-0 pa-0"
                    hide-details=""
                    @change="clicou_so_entradas()"
                    
                    >
                    <template v-slot:label>
                        <span :class="['fs-12']" v-bind="attrs" v-on="on">S.E.⠀</span>
                    </template>
                    </v-checkbox>
                </template>
                <span>Mostrar Somente Entradas</span>
                </v-tooltip>

            </v-col>

            <v-col v-if="(total_juros_aluno)">
                <span >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">

                        <v-chip color="error"  v-bind="attrs" v-on="on">
                            JUROS:
                            <!-- {{ this.getFormatCurrency(total_juros_aluno) }} -->
                            {{ (total_juros_aluno) }}
                        </v-chip>

                    </template>
                    <span> Total com Juros: {{ total_com_juros_aluno }} </span>
                  </v-tooltip>
                  </span>
            </v-col>




            



        <div v-if="0>1">
            <!-- REMOVER CASO NAO USE MAIS ESSES BOTOES DENTRO DESSA DIV-->
            <v-btn
                :color="pro_dados_servico.JA_ASSINADO == 'S' ? 'grey': 'warning'"
                class="ml-2 mt-2"
                dark
                x-small
                @click="imprimir_contrato('CONTRATO',pro_dados_servico,pro_dados_aluno)"
                
            >
                <v-icon
                    small
                    class="mr-2"
                >
                    mdi-text-box 
                    <!-- mdi-printer   -->
                </v-icon>
                <!-- <span v-if="item.JA_ASSINADO!=='S'"> -->
                    contrato
                <!-- </span> -->
                <!-- IMPRIMIR CONTRATO -->
            </v-btn>
            


            &nbsp

            <v-btn
                color="grey"
                dark
                class="ml-2 mt-2"
                x-small
                @click="imprimir_modelo('ficha', items_parcelas, pro_dados_aluno, pro_dados_servico)"
                
            >
                <v-icon small class="mr-2">
                mdi-account-box
                    <!-- mdi-printer   -->
                </v-icon>
                ficha
            </v-btn>

            &nbsp


           

            <v-btn
                color="grey"
                class="ml-2 mt-2"
                dark
                x-small
                @click=" imprimir_modelo('pre-solicitacao', items_parcelas, pro_dados_aluno, pro_dados_servico)"
                
            >
                <v-icon small class="mr-2" color="white">
                    mdi-book-open-outline
                    <!-- mdi-printer   -->
                </v-icon>
                pré-solicitação
            </v-btn>




            &nbsp

            <v-btn
                color="grey"
                class="ml-2 mt-2"
                dark
                x-small
                @click="imprimir_modelo('carne', items_parcelas, pro_dados_aluno, pro_dados_servico)"
                
            >
                <v-icon small class="mr-2" color="white">
                    mdi-book-open-outline
                    <!-- mdi-printer   -->
                </v-icon>
                carnê
            </v-btn>


            &nbsp

            <v-btn
                color="grey"
                class="ml-2 mt-2"
                x-small
                dark
                @click="imprimir_contrato('IMPRESSÃO',pro_dados_servico,pro_dados_aluno)"
                
            >
                <v-icon
                    small
                    class="mr-2"
                >
                    mdi-text-box
                </v-icon>
                    declaração
            </v-btn>
        </div>


           <v-spacer></v-spacer>

            &nbsp 
            <v-col
            cols="5"
            md="2"
            >
                <v-text-field
                dense
                class="my-0"
                v-model="search"
                v-if="items_parcelas.length>0"
                clearable
                append-icon="mdi-magnify"
                label="Procurar"                
                hide-details
                @keyup.esc="search=''"
                >
                </v-text-field>
            </v-col>


        </v-card-title>

        <!-- DSI -->
        <!-- {{ emp }} -->

        <v-data-table
            v-model="selected"
            item-key="CODIGO"

            :show-select="true"
            :single-select="false"

            @contextmenu:row="rightClick"
            @click:row="seleciona_linha"

            v-if="(items_parcelas.length>0)"
            :headers="items_header"
            :items="items_parcelas"
            
            class="elevation-4"
            :item-class= "rowClass" 

            :items-per-page="-1"

            dense
            :search="search"
            :mobile-breakpoint="55"

            :height="retorna_altura( (isMobile ? 300 : 350))"
            :hide-default-footer = "true"

            fixed-header

            
        >
        <!-- :item-class= "rowClass"  -->
        

            <template v-slot:item.SERVICO_REFERENTE="{ item, index }">



                <v-chip 
                  color="grey lighten-0"
                  small dark class="ma-1" 
                >
                  {{ item.FORMA_PAGAMENTO }}
                </v-chip>
                

                <v-chip v-if="(item.TIPO=='E') && (item.PLANO !=='1/1')" small 
                     :color="(item.PLANO=='0')?'green lighten-3': 'blue lighten-3'">
                     {{ (item.PLANO=='0') ? 'ENTRADA' : 'PARCELA' }}    
                </v-chip>


                <v-chip 
                  :color="(item.TIPO=='E') ? 'green lighten-3' : 'red lighten-3'"
                  small class="font-weight-medium ma-1" 
                  v-if="(item.CATEGORIA!='RECEBIMENTO')&&(item.CATEGORIA!='RECEBIMENTOS')"
                >
                  {{ item.CATEGORIA }}
                </v-chip>
                
                <v-chip 
                  :color="(item.TIPO=='E') ? 'blue lighten-3' : 'red lighten-3'"
                  small class="font-weight-medium ma-1" 
                  v-if="(item.SERVICO_REFERENTE!=item.CATEGORIA) && (item.SERVICO_REFERENTE)"
                >
                  {{ item.SERVICO_REFERENTE }}
                </v-chip>
                
                <!-- <v-chip 
                  color="grey lighten-1"
                  small class="ma-1" 
                  v-if="(item.OBSERVACAO)"
                >
                  {{ item.OBSERVACAO }}
                </v-chip> -->


                <span class="ml-0 py-1 bold orange--text" v-if="item.OBSERVACAO">
                    <v-icon
                        v-if="item.OBSERVACAO !== ''"
                        class="ml-1"
                        size="14"
                        color="orange"
                    >
                        mdi-comment-alert 
                    </v-icon>
                    ({{ item.OBSERVACAO }})
                </span>

                
            </template>


            <template v-slot:item.CODIGO="{ item, index }">
                <!-- <span style=" text-align: right; font-size: 10px;" class="grey--text pa-0 mt-2 ml-0"> {{ index + 1 }}º &nbsp </span>   -->
                <!-- <span style=" text-align: right; font-size: 10px;" class="grey--text pa-0 mt-2 ml-0" v-if="(!souDSi)"> {{ index + 1 }}º &nbsp </span>   -->

                <!-- <span style=" text-align: left; font-size: 12px;" class="grey--text pa-0 mt-2 ml-0" > {{ item.CODIGO }} </span>   -->
                <span> {{ item.CODIGO }} </span>  
                <!-- <span>{{ (item.CODIGO) }}</span> -->
            </template>

            <template v-slot:item.PLANO="{ item, index }">
                {{ (item.PLANO=='0') ? 'ENT.' : item.PLANO }}
            </template>


            <template v-slot:item.VISTO="{ item }">
              <div @click="muda_visto(item)">
                <v-icon small color="green" v-if="(item.VISTO=='S')">
                  mdi-check-bold 
                </v-icon>
                <v-icon small  v-else>
                  mdi-radiobox-blank 
                </v-icon>
            </div>
            </template>


            <template v-slot:item...="{ item }">
                <v-icon             
                    class="pa-0 "
                    color="blue"
                    size="20"
                    @click="abre_menu(item)"
                >
                    <!-- mdi-dots-vertical -->
                    mdi-menu
                </v-icon> 
                <!-- @click="editar_tabela(item, 'edita_parcelas', 'dialog_alterar_parcela')" -->
                
                &nbsp

            </template>

            <!-- <template v-slot:item..="{ item }">
                <v-icon             
                    class=""
                    color="red"
                    size="22"
                    @click="remover_tabela('conta',item, '')"
                    v-if="(item.PAGO=='N')"
                >
                    mdi-delete-circle-outline 
                </v-icon> 
            </template> -->

            <template v-slot:item.TIPO="{ item, index }">
                <span style=" text-align: right; font-size: 10px;" class="grey--text pa-0 mt-2 ml-0"> {{ index + 1 }}º &nbsp </span>
                <v-icon v-if="(item.TIPO=='E')" color="success" size="18"> mdi-alpha-e-circle </v-icon> 
                <v-icon v-if="(item.TIPO=='S')" color="error" size="18"> mdi-alpha-s-circle </v-icon> 


                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon class="px-1" size="18" color="black" v-if="item.PIX_URL" v-bind="attrs" v-on="on">
                            mdi-barcode 
                        </v-icon>

                    </template>
                    <span> Fatura Gerada </span>
                  </v-tooltip>

            </template>
            
            
            <template v-slot:item.double_VALOR="{ item }">
                <strong>
                  R$ {{ item.double_VALOR }}
                </strong>
            </template>
            
            <template v-slot:item.double_TOTAL="{ item }">
                <v-chip
                    :color="(item.TIPO=='S')? 'error' : (item.PAGO=='S' ) ? 'green' :  'green'" 
                    small class="ma-1" dark
                >
                    R$ {{ item.double_TOTAL }}
                </v-chip>
            </template>
            
            
            <template v-slot:item.double_JUROS="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                            <span
                             v-bind="attrs"
                             v-on="on"
                             :class="[strtofloat(item.double_JUROS)>0 ? (item.COBRAR_JUROS=='0') ? 'orange--text bold' : 'red--text bold' : '']"
                            >
                            <!-- :class="[strtofloat(item.double_JUROS)>0 ? 'red--text bold' : '']" -->
                                {{ item.double_JUROS }}
                            </span>

                        </template>                    
                        <span v-html="item.JUROS_MSG" v-if="strtofloat(item.double_JUROS) > 0"></span>
                  </v-tooltip>
            </template>
            
            <template v-slot:item.double_TAXA="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                            <span
                             v-bind="attrs"
                             v-on="on"
                             :class="[strtofloat(item.double_TAXA)>0 ? 'pink--text bold' : '']"
                            >
                               {{ item.double_TAXA }}
                            </span>

                        </template>                    
                  </v-tooltip>
            </template>


            
            <template v-slot:item.DATA_VENCIMENTO="{ item }">
                <span
                   v-if="item.PAGO !=='S'"
                   
                   class="bold"
                >
                <!-- :style= "{ color: getVencido(today,item.DATA_VENCIMENTO)}" -->
                  {{ getFormatDate(item.DATA_VENCIMENTO) }}
                </span>

                <span
                v-else
                class="font-weight-medium"
                >
                  {{ getFormatDate(item.DATA_VENCIMENTO) }}
                </span>
            </template>
            
            <template v-slot:item.DATA_EFETUADO="{ item }">


                 <!-- <span
                  v-if="(item.PAGO == 'S')"
                  :class="[(item.PAGO == 'S') ? 'green--text':'', 'font-weight-medium']"
                 >
                   <h3>
                    {{ getFormatDate(item.DATA_EFETUADO) }}
                   </h3>
                 </span> -->

                <v-chip  
                  v-if="(item.PAGO == 'S')"  small class="pa-2 fs-12 white--text font-weight-medium" color="grey"
                >        
                <v-icon left size="12" class="pl-1" color="">
                    mdi-check-bold
                </v-icon>            
                  {{ item.x_DATA_EFETUADO }}   
                </v-chip>


                 <!-- IMPRIMIR RECIBO -->
                 <v-icon
                    color="primary"
                    @click="imprimir_recibo(item, 'RECIBO')"
                    v-if="item.PAGO == 'S'"
                    class="pl-1"
                    size = "18"
                > 
                    mdi-printer 
                </v-icon>
            

                <v-chip
                    color="blue"
                    class="ml-1"
                    small dark
                    v-if="((item.PAGO !=='S')&&(pode_gerar()))"
                    @click="abre_efetuar(item)"
                >
                  
                <v-icon left size="12" class="" color="">
                    mdi-dots-circle
                </v-icon>

                <span class="">EFETUAR</span>

                <!-- <v-icon right size="12" class="pr-1" color="">
                    mdi-dots-circle
                  </v-icon> -->
                  

                </v-chip>
            </template>

        </v-data-table>
        </v-card>
    </v-container>

  </div>

</template>

<script>

import axios from "axios";

import DSibasico from '../assets/js/DSi_basico'//chamo funcao do arquivo
// import {getKEYsql} from '../assets/js/DSi_basico'
import DSisql from '../assets/js/DSi_sql'//chamo funcao do arquivo
import DSiAsaas from '../assets/js/DSi_asaas'//chamo funcao do arquivo
import { negritoO } from '../assets/js/DSi_sql'
import { logado } from '../assets/js/DSi_rotinas'
import { registra_log} from '../assets/js/DSi_login'

var url_app =  sessionStorage['url']

export default {

    components:{
    //    print_recibo_Vue
    },

    props:{
        pro_ide: String,
        pro_cod_servico: String,
        pro_dados_aluno: Object,
        pro_dados_servico: Object
    },

    data: () => ({

        etapa_novo:0,
        recibo_unico: false,
        tem_sequencia : false,

        meia_folha: true,

        num_modelo:'1',
        sel_num_aulas:2,
        total_juros_aluno:0,
        total_com_juros_aluno:0,

        palmas_araucaria: false,

        parcelas_excluidas: false,

        data_chemin:'',

        obj_dados_empresa:null,
        obj_dados_cliente:null,

        checkbox_efetuado: false,
        check_juros_aqui: false,

        modal_items : [],
        imprimindo: false,

        modelo_impressao:'',

        admins: [
        ['Management', 'mdi-account-multiple-outline'],
        ['Settings', 'mdi-cog-outline'],
      ],
      cruds: [
        ['Create', 'mdi-plus-outline'],
        ['Read', 'mdi-file-outline'],
        ['Update', 'mdi-update'],
        ['Delete', 'mdi-delete'],
      ],


        checkbox_so_entradas: false,

        podeFaturar: false,
        souDSi: false,
        can_show: false,
        urlLogo:'',  


        overlay: false,
        overlay2: false,

        search_input_forma:'',

        obj_user: {},

        def:{motivo_processo:''},  
        dialog_opcoes: false,
        itens_categoria:['A','B','C','D','E'],
        opcao_categoria:'',
        tipo_definicao:'',

        showJuros: false,

        selected: [],
        menu_parcelas: [],
        obj_clicado: {},
        tabela_selecionada: '',
        selecionou_varios: false,

        obj_recibo_unico: {},
        valor_recibo:'',

        menu_um: [],

        export_parcelas:[],

        emp:{},
        config_pix: null,
        config_emp:{},

        ide:69,
        cod_servico : 65,

        timer_digitou: null,
        timer_digitou_servico: null,

        dialog_print: false,

        nVias: '2',
        objVias:[],
        // objVias:[
        //     {n:0},{n:1}
        // ],
        

        valido:false,
        valido2:false,
        valido3:false,

        search:'',

        total_recebido:0,
        prorrogar_parcial:0,

        permissoes:{
           gerarparcelas: true,
        },

        combobox_servico:{},
        items_tabela_servico: [],

                items: [
          'Programming',
          'Design',
          'Vue',
          'Vuetify',
        ],

        hoje :'',
        hoje_week:'',
        hora :'',
        data_hora :'',
        today :'',
        quem_alterou:'',

        snackbar: false,
        snack_text: 'My timeout is set to 2000.',
        snack_color: "success",

        refresh_entrada: false,

        valores_digitou:[],

        inicio: 0,
        multi:false,
        primeira_parcela: true,
        checkbox_entrada: true,
        checkbox_parcial: true,
        checkbox_juros: true,
        checkbox_recibo: true,

        notnullRules: [
            v => !!v || 'necessário'
        ],

       acimaZero: [
        v => !!v || 'necessário',
        v =>( (parseInt(v) > 0) ) || 'necessário'
       ],

       ate45: [
        v => !!v || 'necessário',
        v =>( (parseInt(v) > 0) && (parseInt(v) <= 45)) || 'necessário'
       ],

        items_parcelas:[],
        items_header: [],

        items_tabela_contas: [],
        items_tabela_formas: [],

        obj_dados_aluno:{},
        obj_dados_servico:{},

        dialog_gerar_parcela: false,
        dialog_alterar_parcela:false,
        dialog_efetuar: false,
        
        dialog_menu: false,
        item_menu:{},

        edita_gerar_parcelas:{
         COBRAR_JUROS: '',
         TAXA: 0,
         TOTAL: 0,
         FORMA:'',
         TIPO:'',
         DATA_VENCIMENTO:'',
         EFETUAR:'',
         PARCELAS:1,
         SERVICO_REFERENTE:'',
         CODIGO_SERVICO: 0,
         CODIGO_CLIENTE: 0,
         CODIGO_CONTA: 0,		
        },

        def_parcelas:[
            {CODIGO:10, TOTAL:0, FORMA:'', DATA_VENCIMENTO:'', DATA_EFETUADO:'', SERVICO_REFERENTE:''},
        ],

        edita_parcelas:{},
        edita_copia:{},
        obj_valores:{},
        obj_imprimir:{},

        formas_pagamentos:[
            'DINHEIRO',
            'PIX',
            'TRANSFERENCIA',
            'CARTAO DE CREDITO',
            'CARTAO DE DEBITO',
            'BOLETO',
            'CHEQUE'
        ],

        lista_efetuar:['HOJE','NO VENCIMENTO','PENDENTE'],
        lista_parcelas: [
            '1','2','3','4','5','6','7','8','9','10',
            '11','12','13','14','15','16','17','18','19','20',
            '21','22','23','24','25','26','27','28','29','30',
            '31','32','33','34','35','36','37','38','39','40',
            '41','42','43','44','45','46','47','48','49','50',
            '51','52','53','54','55','56','57','58','59','60'
            ],
    }),


    watch:{


        meia_folha(a){
            localStorage['ls_meia_folha']  = JSON.stringify(a)
        },

        total_juros_aluno(a){
            this.total_com_juros_aluno =  
                    (
                        parseFloat(String(this.pro_dados_servico.X_SOMAS[0].SUM_TOTAL).replace(',', '.')) +
                        parseFloat(String(a).replace(',', '.'))
                    ).toFixed(2);

            this.total_com_juros_aluno =  this.getFormatCurrency(this.total_com_juros_aluno)
        },

        selected(val){
          this.selecionou_varios = (this.selected?.length > 1)  

          //limpa recibo unico
          if (!this.selecionou_varios){
            this.obj_recibo_unico = {}
          }
        },

        'edita_gerar_parcelas.PARCELAS'(a){
            this.multiplica()
        },

        'edita_gerar_parcelas.TOTAL'(a){
            this.multiplica()
        },
        
        'edita_gerar_parcelas.DATA_VENCIMENTO'(a){
            this.multiplica()
        },
        

        pro_ide(){//CARREGA TODA VEZ QUE MUDA DE CLIENTE LA NO CADASTRO
            this.refresh()
        },

        dialog_gerar_parcela(a){
            this.check_juros_aqui = false
        },

        dialog_alterar_parcela(a){
            // alert('b')
            // caso tenha taxa entao mostra
            let taxa    = this.strtofloat(this.edita_parcelas.double_TAXA) || 0
            this.check_juros_aqui = (taxa > 0)
            
        },
    },

    created(){
        this.onCreated()
    },



    mounted() {

        window.addEventListener('beforeprint', () => {
            // console.log('Usuário abriu a impressão');
            // alert('before')
        });

        window.addEventListener('afterprint', () => {
            // console.log('Usuário fechou a impressão');
            // this.reciboImpresso();
        });

    },


    
    methods:{


        async go_imprimir_recibo(item, qt, q_alterou){

            // console.log('item:', item);
            
            if ( (qt==1) || (this.etapa_novo == 4) ){

                if (!confirm(`Deseja Imprimir Recibo?`)){

                    this.etapa_novo = 0
                    sessionStorage['etapa_novo'] = this.etapa_novo

                    return false   
                }
            }

            let primeiro

            if (this.etapa_novo == 4){

                this.etapa_novo = 5

                // pega o primeiro efetuado
                let primeiro = this.items_parcelas?.[0]


                if (primeiro?.PAGO === 'S') {
                    this.imprimir_recibo(primeiro, 'RECIBO')
                }else{
                    alert('Parcela não encontrada! Tente imprimir manualmente.')
                }

            }
            else{
                // normal

                if (qt==1){
                    
                    this.etapa_novo = 0

                    
                    primeiro = this.items_parcelas?.find(item => item.QUEM_ALTEROU === q_alterou) || {}
                    // console.log('primeiro:', primeiro);
                    
                    this.imprimir_recibo(primeiro, 'RECIBO')
                    
                    // ja deixo ele selecionado
                    this.selected = primeiro ? [primeiro] : []



                }
            }



            sessionStorage['etapa_novo'] = this.etapa_novo

        },


        async RECIBO_SALVA(item){

            // alert(this.tem_sequencia)
            // se ja tem sequencia nao precisa salvar
            if (this.tem_sequencia){
                return true
            }


            let Scodigo = ''
            let codigo  = ''
            let svalor  = ''

            if (this.recibo_unico){
               item = Object.assign({}, this.obj_recibo_unico)
               Scodigo =  item.NUMEROS
               codigo  =  0
               svalor  =  item.TOTAL
            }
            else{
                item = Object.assign({}, this.item_menu)
                Scodigo = item.CODIGO
                codigo  = item.CODIGO
                svalor  = item.double_TOTAL
            }


            let valorF = parseFloat(
            (svalor || '0').replace(/\./g, '').replace(',', '.')
            );


            // add verificando campos que nao podem duplicar
            let sql = 
                `
                INSERT INTO recibo_impressos
                (
                    CODIGO_CADASTRO,
                    CODIGO_OPERADOR,
                    CODIGO_CONTA,
                    SEQUENCIA,
                    DATA,
                    QUEM_IMPRIMIU,
                    double_VALOR,
                    CODIGO_CONTA_STRING
                )
                SELECT
                    ${this.pro_dados_aluno.CODIGO_ALUNO},
                    ${this.obj_user.CODIGO},
                    ${codigo},
                    ${item.SEQUENCIA},
                    '${this.today}',
                    '${this.quem_alterou}',
                    '${valorF}',
                    '${Scodigo}'
                FROM DUAL
                WHERE NOT EXISTS (
                    SELECT 1
                      FROM recibo_impressos
                    WHERE 
                      SEQUENCIA = ${item.SEQUENCIA}
                      OR CODIGO_CONTA_STRING = '${Scodigo}'
                );

                `

            // console.log('sql:', sql);
            let rr = await  this.crud_sql(sql)
            // console.log('rr:', rr);

            if (rr.includes('#')) {
                alert('Sequencia ja foi salva!\nTente imprimir novamente.')

                this.dialog_print = false//fecho para poder gerar nova sequencia

                return false 

            }
            else{
                this.tem_sequencia = true

                return true
            }
            

            
        },

        async RECIBO_SEQUENCIA(codigo){

            let sql = `
                SELECT 
                    IFNULL(
                        (
                            SELECT SEQUENCIA
                            FROM RECIBO_IMPRESSOS
                            WHERE CODIGO_CONTA_STRING = '${codigo}'
                            LIMIT 1
                        ),
                        (
                            SELECT IFNULL(MAX(SEQUENCIA), 99)
                            FROM RECIBO_IMPRESSOS
                        )
                    ) AS SEQUENCIA,

                    IF(
                        EXISTS (
                            SELECT 1
                            FROM RECIBO_IMPRESSOS
                            WHERE CODIGO_CONTA_STRING = '${codigo}'
                        ),
                        'J',
                        'N'
                    ) AS TIPO;

                `

            // console.log('sql:', sql);
            let rr = (await this.crud_abrir_tabela(sql, false))[0] || false
            if (rr){

                // console.log('rr:', rr);

                // ja tem sequencia..usa a mesma
                if (rr.TIPO == 'J'){

                    this.tem_sequencia =  true

                    return rr.SEQUENCIA * 1
                }
                // novo entao adiciona
                else if (rr.TIPO == 'N'){

                    this.tem_sequencia =  false

                    let ns = (rr.SEQUENCIA * 1) + 1
                    return ns
                }
            }else{
                alert('Ops, verifique a sequencia do recibo!')
                return 0
            }
            
            
        },



        async clicou_em(acao, item){
            if (acao == 'CHECK_JUROS_AQUI'){
                if ((!item)&&(this.edita_parcelas.double_TAXA.length>0)){
                    if (confirm(`Zerar o campo Taxa?`)){
                        this.$set(this.edita_parcelas, 'double_TAXA', 0)
                    }
                }
            }
        },

        async calcularDataVencimento(dataInput) {

            const data = new Date(dataInput+' 00:00:00'); // espera algo como '2025-04-15' ou objeto Date
            const dia = data.getDate();
            let vencimento = new Date(data);


            if (dia <= 15) {
                vencimento.setMonth(vencimento.getMonth() + 1);
                vencimento.setDate(7);
                // alert(vencimento + '\n'+ 7)
            } else {
                vencimento.setMonth(vencimento.getMonth() + 1);
                vencimento.setDate(20);
                // alert(vencimento + '\n'+ 20)
            }
            
            // if (dia <= 15) {
            //     vencimento.setMonth(vencimento.getMonth() + 1);
            //     vencimento.setDate(7);
            //     alert(vencimento + '\n'+ 7)
            // } else if (dia <= 26) {
            //     vencimento.setMonth(vencimento.getMonth() + 1);
            //     vencimento.setDate(20);
            //     alert(vencimento + '\n'+ 20)
            // } else {
            //     vencimento.setMonth(vencimento.getMonth() + 2);
            //     vencimento.setDate(5);
            //     alert(vencimento + '\n'+ 5)
            // }

            // Formatar como dd/mm/yyyy
            const diaFormatado = vencimento.getDate().toString().padStart(2, '0');
            const mesFormatado = (vencimento.getMonth() + 1).toString().padStart(2, '0');
            const ano = vencimento.getFullYear();

            // alert(`${ano}-${mesFormatado}-${diaFormatado}`)
            return `${ano}-${mesFormatado}-${diaFormatado}`;
        },


        mostrar_tipo_cliente(tipo){
            let tipo_cliente 
            try{ tipo_cliente = this.obj_dados_cliente.TIPO_CLIENTE }
            catch (error) { return false }

            if (!tipo_cliente){
            return false
            }


            // if (tipo_cliente.includes(tipo)){
            if ( [tipo].some(el => tipo_cliente.includes(el)) ){
                // console.log('achou = ', tipo);
                return true
            }
            else{
                return false
            }

        },

        muda_pago(vem){
        
             this.data_hora_agora()

            let r = ''
            if (vem){
                r = 'S'
                // this.edita_parcelas.DATA_EFETUADO = this.today
                this.$set(this.edita_parcelas, 'DATA_EFETUADO'      , this.today)
                this.$set(this.edita_parcelas, 'QUEM_EFETUOU'       , this.quem_alterou)
                this.$set(this.edita_parcelas, 'QUEM_EFETUOU_CODIGO', this.obj_user.CODIGO)
            }
            else{
                r = 'N'
                // this.edita_parcelas.DATA_EFETUADO = null
                this.$set(this.edita_parcelas, 'DATA_EFETUADO'      , null)
                this.$set(this.edita_parcelas, 'QUEM_EFETUOU'       , '')
                this.$set(this.edita_parcelas, 'QUEM_EFETUOU_CODIGO', 0)
            }

            // this.edita_parcelas.PAGO = r
            this.$set(this.edita_parcelas, 'PAGO', r)

        },

        go_carne_faturas(){
            
            this.dialog_menu  =false

            this.modelo_impressao = 'CARNE_FATURAS'

            // copio o array ja ordenando pelo campo DATA_VENCIMENTO
            this.modal_items = [...this.selected]
                .filter(item => item.PIX_URL && item.PAGO === 'N') // Filtra os itens com PIX_URL preenchido e PAGO = 'N'
                .sort((a, b) => {
                    const dateA = new Date(a.DATA_VENCIMENTO); // Converte DATA_VENCIMENTO para objeto Date
                    const dateB = new Date(b.DATA_VENCIMENTO);
                    return dateA - dateB; // Ordena em ordem ascendente
                });


                

                // imprimir_modelo
                sessionStorage['recibo_tipo']           = 'carne_asaas'
                sessionStorage['modal_items']           = JSON.stringify(this.modal_items)
                sessionStorage['recibo_dados_cadastro'] = JSON.stringify(this.pro_dados_aluno)



                // Transformar o objeto em string e salvar em sessionStorage
                // sessionStorage['recibo_dados_parcela']  =  JSON.stringify(dados_parcela)
                // sessionStorage['recibo_dados_parcela']  =  JSON.stringify(h)
                // sessionStorage['recibo_dados_servico']  =  JSON.stringify(false)

                let route = this.$router.resolve({path: '/print_c'});
                window.open(route.href, '_blank');

                
            return false    
            this.dialog_print = true

            this.mudaVias(this.nVias)


                return false

            // monto o objeto que sera lido la em relatorios.vue
            let obj_dados_impressao = {}

            this.$set(obj_dados_impressao, 'relatorios_show'    , true) //permite ver relatorio
            this.$set(obj_dados_impressao, 'qual'               , 'CARNE_ASAAS')
            this.$set(obj_dados_impressao, 'modelo_relatorio'   , 'CARNE_ASAAS')
            // this.$set(obj_dados_impressao, 'componente'         , componente)
            // this.$set(obj_dados_impressao, 'headers'            , headers)
            // this.$set(obj_dados_impressao, 'items'              , items)
            // this.$set(obj_dados_impressao, 'titulo'             , titulo)
            // this.$set(obj_dados_impressao, 'auto_print'         , auto_print )
            // this.$set(obj_dados_impressao, 'ocultar_header'     , ocultar_header) 
            this.$set(obj_dados_impressao, 'largura'            , '100%') 



            // salvo na session para ser lido em relatorios.vue
            sessionStorage['obj_dados_impressao']  =  JSON.stringify(obj_dados_impressao)

            // abro a pagina relatorios.vue
            // let route = this.$router.resolve({path: '/relatorios'});
            // window.open(route.href, '_blank');



        },


        gerarQRCode(link){

            let ss = ''
            if (link){
                ss = `https://dsi.app.br/qrcode/qrcode.php?s=qrl&d=${link}`
                //console.log('ss:', ss);
                return ss
            }
            else {
                return ''
            }
        },

        async go_gerar_faturas(){

            this.dialog_menu = false
            this.overlay2     = true

            let percorrer = this.selected.map((x) => x);//clonar array selecao para pegar os codigos ja selecionados

            let linha
            for (let i = 0; i < this.selected?.length; i++){
                linha = this.selected[i]

                // console.log('linha:', linha);

                if ( (linha.PAGO=='N')&&(!linha.PIX_ID) &&(linha.TIPO=='E') ) {
                    await this.pre_gerar_pix(linha, false)
                }else{
                    console.log('esse nao gera:', linha);
                    
                }
                
            }

            setTimeout(async () => {
                await this.atualizaSelecao('items_parcelas');
                this.overlay2     = false


                if (confirm(`Imprimir o Carnê das Faturas?`)){
                    this.go_carne_faturas()
                }
                

            }, 999);

        },

        clicou_so_entradas(){
            this.tabela('conta','update')
            this.manda_emit('update_somas', this.checkbox_so_entradas)//manda update na janela Cadastro.vue
        },

        async atualizaSelecao(item_name){

            let percorrer = this.selected.map((x) => x);//clonar array selecao para pegar os codigos ja selecionados
            this.selected = []//limpo a selecao
            for (let i = 0; i < percorrer?.length; i++){//percorro o clone dos codigos selecionados

                // console.log('percorrer[i]:'+ i);
                // console.log(percorrer[i]);

                if (percorrer[i]){
                let achar = this[item_name].filter(x => (x.CODIGO === percorrer[i].CODIGO));//clono somente os codigos da lista atualizada
                achar = achar[0] //trasnformo array em objeto
                // console.log('achar:', achar);
                this.selected.push(achar) //preenchendo array com o objeto clonado
                }
            }

        },

        async imprimir_recibo_unico(){

            let qt = this.selected.length
            let linha = {}
            let soma  = 0
            let taxa  = 0
            let valor = 0
            let nums  = ''

            this.recibo_unico = true//uso para o campo sequencia

            this.obj_recibo_unico = {}

            for (let i = 0; i < qt; i++){

                linha = this.selected[i]

                if ((linha.PAGO=='S') && (linha.TIPO == 'E')){
                    try{

 
                    taxa    = this.strtofloat(linha.double_TAXA) || 0
                    if (taxa > 0){
                        valor = linha.double_VALOR //SE TIVER TAXA PEGA O VALOR ORIGINAL    
                    }
                    else{
                        valor = linha.double_TOTAL//senao pega o valor total pago
                    }

                    // soma += parseFloat(this.strtofloat(linha.double_TOTAL))
                    // console.log('valor:',valor);
                    soma += parseFloat(this.strtofloat(valor))
                    // console.log('soma:',soma);

                    nums = `${linha.CODIGO}, ${(this.obj_recibo_unico.NUMEROS) || ''}`
                    nums = nums.replace(/[,\s]+$/, '')
                    
                    this.$set(this.obj_recibo_unico   , 'TOTAL', soma )
                    this.$set(this.obj_recibo_unico   , 'NUMEROS', nums )
                    

                    }catch(e){
                    alert(`Erro na somatório do Recibo Único\n${e}`)  
                    return false
                    }
                }
                else{
                    alert(`Lançamento Nº${linha.CODIGO} não foi Efetuada!`)
                }
                
                // console.log('linha:', linha);
            }


            // define o valor que aparecera no recibo
            // this.valor_recibo = soma
            this.valor_recibo = this.valor_recibo = soma.toLocaleString('pt-BR', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                        });//formato 


            this.dialog_menu = false

            // caso nao tenha nenhuma parela efetuada selecionada
            if(Object.keys(this.obj_recibo_unico).length === 0){
                return false
            }



            // busco a sequencia do recibo e add no item
            let seq = await this.RECIBO_SEQUENCIA(this.obj_recibo_unico.NUMEROS)


            this.$set(this.obj_recibo_unico   , 'REFERENTE'             , this.pro_dados_servico.DESCRICAO + ` - PARCELAS Nº: ${this.obj_recibo_unico.NUMEROS}`)
            this.$set(this.obj_recibo_unico   , 'TOTAL'                 , this.floatTostring(soma) )
            this.$set(this.obj_recibo_unico   , 'DATA'                  , this.hoje) 
            this.$set(this.obj_recibo_unico   , 'QUEM_EFETUOU'          , DSibasico.get_quem_alterou() )
            this.$set(this.obj_recibo_unico   , 'SEQUENCIA'             , seq )

            this.imprimir_recibo(false, 'RECIBO')
            


        },

        clicou_menu_parcelas(acao){
            // alert(acao)
            this.acao_atual = acao



            if (acao == 'all_recibo_unico'){
               this.imprimir_recibo_unico()
            }

            else if (acao == 'all_gerar_faturas'){
                
               if (!confirm(`Gerar Faturas ${this.config_emp.PIX_PLATAFORMA}`)){
                   return false
               }

               this.go_gerar_faturas()
            }

            else if (acao == 'all_carne_faturas'){

               this.go_carne_faturas()
            }
            
            else if (acao == 'all_excluir_parcelas'){

               this.go_all_excluir_parcelas()
            }
       },

       vif_here(acao){

          if (acao == 'all_carne_faturas'){
            return  (this.pode_imprimir()) &&(this.item_menu.PIX_ID)
            // return true
          }
          
          else if (acao == 'all_excluir_parcelas'){
            // return  (this.obj_user.SUPER=='S')  
            // return true
            return this.pode_excluir()
          }
          
          else if (acao == 'all_gerar_faturas'){
            return  (this.pode_alterar()) && (this.item_menu.PAGO=='N')&&(!this.item_menu.PIX_ID) &&(this.item_menu.TIPO=='E')
            // return true
          }

          else if (acao == 'all_recibo_unico'){
            // return  (this.souDSi)&&(this.item_menu.PAGO=='N')&&(!this.item_menu.PIX_ID) &&(this.item_menu.TIPO=='E')
            return true
          }
          
          else if (acao == 'ÍTENS SELECIONADOS'){
            return this.selecionou_varios
            return true//somente para testar
         }
       },

        monta_menu_parcelas(){
            this.menu_parcelas.push(           

                {
                    type:'group',
                    icon:'mdi-square',
                    icon_color: 'grey',
                    title: 'ÍTENS SELECIONADOS',
                    click: '', 
                    active: true, 
                    items: [
                        {type:'', title: 'Recibo Único',  icon:'mdi-printer', icon_color: 'primary',  click:'all_recibo_unico' },
                        {type:'', title: `Gerar Faturas (${this.config_emp.PIX_PLATAFORMA})` ,  icon:'mdi-barcode', icon_color: 'black',  click:'all_gerar_faturas' },
                        {type:'', title: 'Carnê das Faturas',  icon:'mdi-printer', icon_color: 'primary',  click:'all_carne_faturas' },
                        {type:'', title: `Excluir Parcelas`,  icon:'mdi-close-box-multiple', icon_color: 'red',  click:'all_excluir_parcelas' },
                    ],
                },
            )
        },

       async pre_gerar_pix(dados_parcela, alerta){


            let link
            let token

            if (this.config_emp.PIX_SITUACAO == 'TESTE'){
                token = this.config_pix.PIX_TOKEN_TESTE
                link  = this.config_pix.PIX_LINK_TESTE
            }
            else if (this.config_emp.PIX_SITUACAO == 'PRODUÇÃO'){
                token = this.config_pix.PIX_TOKEN
                link  = this.config_pix.PIX_LINK
            }
            else{
                alert('Plataforma de Cobrança não definida!')
                return false
            }


            if (alerta){
                if (!confirm(`Gerar Fatura ${this.config_emp.PIX_PLATAFORMA} ?`)){
                    return false
                }
            }



             // ALGUMAS VERIFICACOES
             if (!this.pro_dados_aluno.CPF){
                alert('Preencha o campo CPF')
                return false
             }


            let retorno = await this.gerar_pix(dados_parcela, this.pro_dados_aluno, link, token)

            if (retorno){

                if (alerta){

                    let pagina_retorno = retorno.invoiceUrl

                    if (confirm(`Visualizar a Fatura?`)){
                        window.open(pagina_retorno, '_blank');
                    }
                }

                setTimeout(function(){
                    this.tabela('conta','update')//refresh
                }.bind(this), 555);//1100
            }
            else{

            }

          
       },

       ver_cobranca_pix(item){
          window.open(item.PIX_URL, '_blank');
       } ,

       async pix_id_aluno(link, token, dados_aluno){


            // ALGUMAS VERIFICACOES
            if (!dados_aluno.CPF){
                alert('Preencha o campo CPF')
                return false
            }

            let tipo_id_aluno = 'CODIGO_ALUNO' 
            
            let cpf           = await DSibasico.somenteNumeros(dados_aluno.CPF)
            let url           = ''
            let ref           = ''

            if (tipo_id_aluno == 'CODIGO_ALUNO'){
                
                ref = dados_aluno.CODIGO_ALUNO+'_'+cpf
                
                url = link + 'customers?externalReference=' + ref
                // url = link + 'customers?externalReference=' + dados_aluno.CODIGO_ALUNO
            }
            else if (tipo_id_aluno == 'CPF'){
                url  = link + 'customers?cpfCnpj=' + cpf
            }

            let retorno = await DSiAsaas.sendGetAxios('GET', url, token, null)
            // let retorno = await DSiAsaas.sendGetAxios('POST', url, token, null)

            // tem aluno..retorna id dele
            if (retorno.totalCount>0){
                // console.log('id do cliente:', retorno.data[0].id);
                return  retorno.data[0].id 
            }
            else{
                // caso nao tenha..cadastra novo aluno

                url  = link + 'customers'

                // ENVIO OS CAMPOS NECESSARIOS
                let body  =
                    {
                        name                    : dados_aluno.NOME,
                        // email                   : dados_aluno.EMAIL, //se enviar email .. sera enviado alerta pro aluno tb    
                        cpfCnpj                 : dados_aluno.CPF,
                        postalCode              : dados_aluno.CEP,
                        externalReference       : ref,
                        // addressNumber           : '10',
                        notificationDisabled    : true, //alerta pra o cfc
                    }

                let retorno_2 = await DSiAsaas.sendGetAxios('POST', url, token, body)

                if (retorno_2.id){
                //    console.log('id do cliente cadastrado:', retorno_2.id);
                   return  retorno_2.id
                }
                else{
                  return false 
                }

            }

       }, 

       retorna_altura(menos){
          // let r = '100vh'  
          // let r = '720'
          // let r = (window.innerHeight - 80 - 140)
          let r = (window.innerHeight - menos)
          let height = window.innerHeight;

          return r
       },

       rowClass(item){
        // console.log(item);
        let r = this.getColorLinha(item)

        // console.log(r);
        return r
        // return 'border-bottom';
      },

      getColorLinha (item) {
        
        let r = ''

               
        
        if (item.TIPO == 'S') r =  'red lighten-4'
        else if (item.VISTO == 'S') r =  'green lighten-5'
        else if (item.PAGO == 'S') r =  'green lighten-5'
        else if ( (item.PAGO !='S') && (this.today > item.DATA_VENCIMENTO) ) r = 'orange lighten-4'
        else r = ''

        return r
      },

       meu_keyup2(event,campo,upper){
      
        //identifica se o campo é double e muda o display
        if ((campo.includes('double_') || campo.includes('VALOR')) ){
            this.item_edita[campo] =  this.moeda(event)
            // @keyup="editedItem.double_credito = moeda($event)"
        }
        else if (campo.includes('CEP')) {

            this.consulta_cep(this.item_edita[campo])    
        }
        else{
            if ((campo.includes('EMAIL')==false) &&
            (campo.includes('SENHA')==false) &&
            (campo.includes('SENHA_WEB')==false)){

                if (upper !=='N'){
                this.allUpper(event, campo)
                }
                
            }
        }
      },  

      apertou_enter(event){

        if (!event){ return 'exit' }
        this.items_tabela_formas.unshift(event.toUpperCase())
      },

      cobrar_juros(){

        if (!this.checkbox_juros){

            let valor   = this.strtofloat(this.obj_valores.double_VALOR)
            let taxa    = this.strtofloat(this.obj_valores.double_TAXA) || 0
            
            valor = parseFloat(valor) - parseFloat(taxa) 
            valor = this.floatTostring(valor)

            // this.$set(this.edita_parcelas   , 'double_TOTAL', this.obj_valores.double_VALOR )
            // this.$set(this.edita_copia      , 'double_TOTAL', this.obj_valores.double_VALOR )
            this.$set(this.edita_parcelas   , 'double_TOTAL', valor )
            this.$set(this.edita_copia      , 'double_TOTAL', valor)
            this.$set(this.edita_copia      , 'double_JUROS', '0' )
            // this.total_recebido = this.obj_valores.double_VALOR
            this.total_recebido = valor

        }
        else{
            this.$set(this.edita_parcelas   , 'double_TOTAL', this.obj_valores.double_TOTAL )
            this.$set(this.edita_copia      , 'double_TOTAL', this.obj_valores.double_TOTAL )
            this.$set(this.edita_copia      , 'double_JUROS', this.obj_valores.double_JUROS )
            this.total_recebido = this.obj_valores.double_TOTAL
        }
      },


      muda_visto(item){
        console.log(item);


        if (this.obj_user.SUPER!='S'){
          alert('Somente Super pode alterar o Visto')
          return 'exit'
        }

        if (item.PAGO!='S'){
          alert('Parcela não esta Efetuada, não pode ser vistada!')
          return 'exit'
        }

        if (!confirm("Alterar Visto?")){
          return 'exit'
        }

        let visto = item.VISTO

        if (visto != 'S'){ visto = 'S'} else {visto = 'N'}
        let codigo = item.CODIGO

        let sql = `update conta set conta.VISTO = '${visto}' where CODIGO = ${codigo}`
        this.crud_sql(sql)


        this.atualiza_lista('items_parcelas', item.CODIGO, 'VISTO', visto)
        // ATUALIZA LISTA SEM DAR CLOSE OPEN NA TABELA
        // let index = this.items_conta.indexOf(item)
        // let index = this.items_conta.findIndex( x => x.CODIGO === item.CODIGO );
        // this.$set(item, 'VISTO',  visto)
        // Object.assign(this.items_conta[index], item)

      },

        async atualiza_lista(nome_item, codigo, campo, valor){

            // ATUALIZA LISTA SEM DAR CLOSE OPEN NA TABELA
            let index = this[nome_item].findIndex( x => x.CODIGO === codigo );
            let item = this[nome_item][index]
            this.$set(item, campo, valor)
            Object.assign(this[nome_item][index], item)
        },


        async achar_atrasadas(items){
            // console.log('achar_atrasadas:', items);

            for (var i = 0; i < items.length; i++) {
                let item = items[i]
                if (item.PAGO !='S'){
                    if (this.today > item.DATA_VENCIMENTO){
                        // console.log('ATRASADO', item.DATA_VENCIMENTO);
                        // this.atualiza_lista('items_parcelas', item.CODIGO, 'PAGO', 'S')
                        await this.atualiza_juros(items[i], true, false)//somente calculo.. sem salvar tipo calcfield
                    }
                }
   
            }
        },

        pode_gerar(){
            
            if ( (this.obj_user.SUPER!='S') && (this.obj_user.PARC_GERAR!='S')){
                return false
            }
            else{
                return true
            }   
        },
        
        pode_imprimir(){
            
            if ( (this.obj_user.SUPER!='S') && (this.obj_user.CADASTRO_U!='S')){
                return false
            }
            else{
                return true
            }   
        },
        
        pode_alterar(){
            
            if ( (this.obj_user.SUPER!='S') && (this.obj_user.PARC_ALTERA!='S')){
                return false
            }
            else{
                return true
            }   
        },

        pode_estornar(){
            
            if ( (this.obj_user.SUPER!='S') && (this.obj_user.PARC_ESTORNA!='S')){
                return false
            }
            else{
                return true
            }   
        },

        pode_excluir(){
            
            if ( (this.obj_user.SUPER!='S') && (this.obj_user.PARC_EXCLUI!='S')){
                return false
            }
            else{
                return true
            }   
        },


      async onCreated(){

        if (await logado(this)){
          
            await this.showDrawer(true)
            
            this.souDSi = (sessionStorage['souDSi'] == 'S') ? true : false 
            // this.souDSi = true //@rex

            this.showJuros = (sessionStorage['conf_mostrar_juros'] != 'SIM') ? false : true
            this.refresh()
            this.carrega_dados()
            
            setTimeout(function(){

                this.monta_menu_um()

            }.bind(this), 999);

            this.monta_menu_parcelas()

            //busco objeto no sessionStorage
            this.obj_user = JSON.parse(sessionStorage['obj_user'])
        }
      }, 

      async showDrawer(value){
        this.$emit('executar', value)//mostrar ou nao paineis
        this.can_show = true
        this.isMobile = window.innerWidth < 600
      },



      monta_menu_um(){

        // this.menu_um.push( { menu: 'Imprimir', icon: 'mdi-printer ', icon_color: "blue", click: 'financeiro' } )
        let TIPO_CLIENTE = this.obj_dados_cliente.TIPO_CLIENTE


            // geral pra todos
            this.menu_um.push(           

                // {type:'menu', title: 'Contrato',        icon:'mdi-text-box',            icon_color: '',    click:'contrato' },
                {type:'menu', title: 'Impressão',      icon:'mdi-text-box',             icon_color: '',    click:'declaracao' },
                {type:'menu', title: 'Carnê',           icon:'mdi-book-open',           icon_color: '',    click:'carne' },
                {type:'menu', title: 'Promissória',     icon:'mdi-book-open-outline',   icon_color: '',    click:'promissoria' },
                
            )

        if (TIPO_CLIENTE.includes('CFC')){

            this.menu_um.push(           

                {type:'menu', title: 'Contrato',        icon:'mdi-text-box',            icon_color: '',    click:'contrato' },
                {type:'menu', title: 'Ficha',           icon:'mdi-account-box',         icon_color: '',    click:'ficha' },
                {type:'menu', title: 'Pré-Solicitação', icon:'mdi-book-check-outline ', icon_color: '',    click:'pre-solicitacao' },
                {type:'menu', title: 'Pré-Solicitação 2', icon:'mdi-book-check-outline ', icon_color: 'red',    click:'pre-solicitacao2' },

                {
                    type:'group',
                    icon:'mdi-list-status ',
                    icon_color: 'blue',
                    title: 'Avaliação',
                    click: '', 
                    items: [
                        {type:'', title: 'Aulas Práticas',        icon:'', icon_color: '',  click:'avaliacao_20' },
                    ],
                },
                
            )
        }
        
        if (TIPO_CLIENTE.includes('JURIDICO')){
            //algo especifico daqui
        }

      },


    //   [ { "active": true, "icon": "mdi-printer", "icon_color": "blue", "title": "Imprimir", "click": "financeiro", "items": [ { "title": "Contrato", "icon": "mdi-text-box", "click": "contrato" }, { "title": "Ficha", "icon": "mdi-account-box", "click": "ficha" }, { "title": "Pré-Solicitação", "icon": "mdi-book-open", "click": "pre-solicitacao" }, { "title": "Carnê", "icon": "mdi-book-open", "click": "carne" }, { "title": "Declaração", "icon": "mdi-text-box", "click": "declaracao" } ] }, 
    //     { "title": "Esse", "icon": "mdi-text-box", "click": "declaracao" } 
    //   ]

      clicou_menu_um(acao){
        
        if (acao == 'pre-solicitacao2'){
           this.manda_emit('abrir_pre_solicitacao')
        }

        else if (acao == 'contrato'){
           this.imprimir_contrato('CONTRATO', this.pro_dados_servico, this.pro_dados_aluno)
        }

        else if (acao == 'declaracao'){
            this.imprimir_contrato('IMPRESSÃO', this.pro_dados_servico, this.pro_dados_aluno)
        }


        else if (acao == 'avaliacao_20'){

            // alert('a')
            this.sel_num_aulas =  `${this.pro_dados_servico?.NUM_AULAS}` || '20'
            this.tipo_definicao = 'avaliacao_20'
            this.dialog_opcoes  = true
            return false
            this.imprimir_modelo(acao, this.items_parcelas, this.pro_dados_aluno, this.pro_dados_servico)
        }
        
        else if (acao == 'go_avaliacao_20'){

            // alert('b')
            sessionStorage['opcao_categoria'] = this.opcao_categoria
            sessionStorage['sel_num_aulas']   = this.sel_num_aulas
            sessionStorage['num_modelo']      = this.num_modelo
            acao = 'avaliacao_20'
            this.imprimir_modelo(acao, this.items_parcelas, this.pro_dados_aluno, this.pro_dados_servico)
        }    

        else{
            this.imprimir_modelo(acao, this.items_parcelas, this.pro_dados_aluno, this.pro_dados_servico)
        }
      },


      async salvar_calculando(){

        await this.atualiza_juros(this.edita_parcelas, false, false)//nao uso da tabela-financeiras... uso do proprio campo salvo
        await this.salvar_tabela('conta', this.edita_parcelas,'dialog_alterar_parcela', this.item_menu)
        
      },


      calcula(){
        //if (this.showJuros){
          // console.log('calcula');
          this.atualiza_juros(this.edita_parcelas, false, false)
        //}
      },

      async atualiza_juros(item, usar_tabela, ja_salva){

        let r = await DSibasico.calcular_juros(item, usar_tabela)

        // console.log('atualiza_juros parcelas');
        // console.log(r);
        // console.log(item);

          if (this.showJuros){
            let textoJuros = `${r.dias_atrasado} dias atrasados\n${r.string_juros} \nTotal de Juros: R$ ${r.total_juros}`
            textoJuros     = textoJuros.replaceAll('\n', '<br>') //quebra de linha


            // console.log('vv:', item.CODIGO +' - '+item.COBRAR_JUROS );
            if (item.COBRAR_JUROS == '0'){
                // alert(item.CODIGO +' cobra juros manual')

                let n_valor = this.strtofloat(item.double_VALOR) 
                let n_juros = this.strtofloat(item.double_JUROS)
                let taxa    = this.strtofloat(item.double_TAXA) || 0
                let valor_manual = 0
                valor_manual = parseFloat(n_valor) + parseFloat(n_juros) 
                valor_manual = parseFloat(valor_manual) - parseFloat(taxa)
                valor_manual = this.floatTostring(valor_manual)



                this.$set(item, 'double_TOTAL'  , valor_manual)
                // this.$set(item, 'double_JUROS'  , r.total_juros)
                this.$set(item, 'JUROS_MSG'     , 'Juros Manual')
            }
            else{
                this.$set(item, 'double_TOTAL'  , r.total)
                this.$set(item, 'double_JUROS'  , r.total_juros)
                this.$set(item, 'JUROS_MSG'     , textoJuros)


                // soma os juros para ser utilizado na janela cadastro.vue
                this.total_juros_aluno =
                    (
                        parseFloat(String(r.total_juros).replace(',', '.')) +
                        parseFloat(String(this.total_juros_aluno).replace(',', '.'))
                    ).toFixed(2);

                // console.log(this.total_juros_aluno)
                // console.log(this.pro_dados_servico)
            }
          }
          else{
            this.$set(item, 'double_TOTAL', this.edita_parcelas.double_VALOR)
          }


          // caso queria calcular vindo de um menu ou botao
          if (ja_salva){
            await this.salvar_tabela('conta', item ,'')
          }
          
      },



        async imprimir_recibo_up(tipo, dados_parcela, dados_cadastro, dados_servico){


            sessionStorage['recibo_tipo'] = tipo

            // Transformar o objeto em string e salvar em sessionStorage
            sessionStorage['recibo_dados_parcela']  =  JSON.stringify(dados_parcela)
            sessionStorage['recibo_dados_cadastro'] =  JSON.stringify(dados_cadastro)
            sessionStorage['recibo_dados_servico']  =  JSON.stringify(dados_servico)

            let route = this.$router.resolve({path: '/print_c'});
            window.open(route.href, '_blank');

        },

        imprimir_modelo(tipo, dados_parcela, dados_cadastro, dados_servico){

            sessionStorage['recibo_tipo'] = tipo


            // FILTRO PEGANDO SOMENTE AS PENDENTES
            let h = dados_parcela
            if ((tipo == 'carne') || (tipo == 'promissoria')){
                // h = dados_parcela.filter( x => x.PAGO == 'N' );
                h = dados_parcela.filter( x => x.PAGO == 'N' && x.TIPO == 'E'); //somente entradas e nao saidas
                // console.log(h);
            }



            // Transformar o objeto em string e salvar em sessionStorage
            // sessionStorage['recibo_dados_parcela']  =  JSON.stringify(dados_parcela)
            sessionStorage['recibo_dados_parcela']  =  JSON.stringify(h)
            sessionStorage['recibo_dados_cadastro'] =  JSON.stringify(dados_cadastro)
            sessionStorage['recibo_dados_servico']  =  JSON.stringify(dados_servico)

            let route = this.$router.resolve({path: '/print_c'});
            window.open(route.href, '_blank');

        },

        imprimir_contrato(tipo, servico, cadastro){
 
            //salvo no sessionStorage pq na session ele nao le quando abre em nova guia
 
            
           // Transformar o objeto em string e salvar em sessionStorage
           sessionStorage['print:dados_cadastro']  =  JSON.stringify(cadastro)
           sessionStorage['print:dados_parcelas']  =  JSON.stringify(this.items_parcelas)
           sessionStorage['print:dados_servicos']  =  JSON.stringify(servico)
           sessionStorage['print:dados_impressao']  =  ''


          // console.log('servico:', servico);
          // VEJO SE PEGOU O CONTRATO ASSOCIADO AO SERVIÇO..CASO CONTRARIO ABRO A JANELA DE MODELOS DE IMPRESSAO
           if (!servico.CONTRATO){
            console.log('NÃO ASSOCIOU CONTRATO AO SERVIÇO..ABRINDO MODELOS DE IMPRESSÃO');
            tipo = 'IMPRESSÃO'
           }

           let retorno =  this.replace_texto(tipo, servico, cadastro)

        //    sessionStorage['refresh_cadastro'] =  (tipo=='CONTRATO') ? 'S' : ''
 
           
           sessionStorage['print:get_tipo']       = tipo
           sessionStorage['print:get_codigo']     = servico.CODIGO
           sessionStorage['print:get_descricao']  = servico.DESCRICAO +' - '+servico.PROCESSO 
           sessionStorage['print:get_nome_aluno'] = cadastro.NOME
           
        
           sessionStorage['printConteudo']       = retorno
           sessionStorage['editar_impressao']    = 'N'
            
           sessionStorage['servico_ja_assinou']  = servico.JA_ASSINADO 
           sessionStorage['data_hora']           = this.data_hora
           
 
           let route = this.$router.resolve({path: '/print'});
           window.open(route.href, '_blank');
 
       },


       replace_texto(tipo, servico, cadastro){
 

        // console.log('replace_texto:', );
            // console.log('servico:');
            // console.log(servico);

            // console.log('cadastro:');
            // console.log(cadastro);
                // let texto = this.editor.getHTML()

                let texto = ''
                if (tipo=='CONTRATO'){
                    texto = servico.CONTRATO //PEGO DA TABELA SERVIÇO
                }
                

                //substituindo os campos coringas
                texto = texto.replaceAll('@empresa',        sessionStorage['emp_nome'])
                texto = texto.replaceAll('@razao_social',   sessionStorage['emp_razao'])
                texto = texto.replaceAll('@cnpj',           sessionStorage['emp_cnpj'])
                texto = texto.replaceAll('@endereco_emp',   sessionStorage['emp_endereco'])
                texto = texto.replaceAll('@fones',          sessionStorage['emp_fone1'] + '  '+sessionStorage['emp_celular'])
                texto = texto.replaceAll('@cidade',         sessionStorage['emp_cidade'])
                texto = texto.replaceAll('@data',           this.hoje_week )

                texto = texto.replaceAll('@ide',             'IDE: '+cadastro.CODIGO_ALUNO)
                texto = texto.replaceAll('@nome',            cadastro.NOME)
                texto = texto.replaceAll('@aluno',           cadastro.NOME)
                texto = texto.replaceAll('@rg',              cadastro.RG )
                texto = texto.replaceAll('@cpf',             cadastro.CPF)
                texto = texto.replaceAll('@nascimento',      cadastro.x_DATA_NASCIMENTO)
                texto = texto.replaceAll('@processo',        cadastro.PROCESSO)
                texto = texto.replaceAll('@endereco_al',     cadastro.ENDERECO+' '+cadastro.BAIRRO+' CEP:'+cadastro.CEP+' '+cadastro.CIDADE+' - '+cadastro.UF)

                texto = texto.replaceAll('@servico',         servico.DESCRICAO)
                texto = texto.replaceAll('@categoria',       servico.CATEGORIA)
                texto = texto.replaceAll('@valor_servico',   servico.x_double_TOTAL)

                if (texto.includes('@estrutura pagamento')){
                
                    // console.log(this.items_parcelas);
                    let parcelas = this.items_parcelas

                    let TITULO = ''
                    let DESC   = ''

                    TITULO = '<br>IDE:'+cadastro.CODIGO_ALUNO +'   -   PROCESSO: '+ servico.PROCESSO + '\n'+
                             'PLANO DE PAGAMENTO:'+ '<br>'

                    for (var i = 0; i < parcelas.length; i++) {

                        // console.log(parcelas);
                        if ((i == 0) && (parcelas[i].PAGO == 'S')){

                            let parcelado = Number(this.strtofloat(servico.double_TOTAL))   - Number(this.strtofloat(parcelas[i].double_TOTAL))

                            TITULO += 'VALOR TOTAL: '+ servico.x_double_TOTAL + ' | '+
                                      'ENTRADA: '+ parcelas[i].x_double_TOTAL + ' | '+
                                      'PARCELADO: R$ '+ this.getFormatCurrency(parcelado)+'<br>'

                        }else{
                            DESC += i +'ª parcela: '+ this.getFormatDate(parcelas[i].DATA_VENCIMENTO) + '   ' + parcelas[i].x_double_TOTAL + ' = '+parcelas[i].SERVICO_REFERENTE +'<br>'
                            
                        }

                    }

                    // console.log(TITULO);
                    TITULO += DESC

                    texto = texto.replaceAll('@estrutura pagamento', TITULO)
                }
                

                

                return texto

                // this.editor.commands.setContent(texto)

        },


        retorna_taxa(taxa, tipo_taxa, valor){

            taxa      = this.strtofloat(taxa)

            if (taxa > 0){

                let novo_valor = this.strtofloat(valor)
                let taxa_salvar = 0

                if (tipo_taxa == '%'){
                    taxa_salvar = ((novo_valor * taxa) / 100 )
                    novo_valor = novo_valor - taxa_salvar
                    // console.log('%:'+novo_valor);
                }else if (tipo_taxa == '$'){
                    taxa_salvar = taxa
                    novo_valor = novo_valor - taxa
                    // console.log('$:'+novo_valor);
                }

                novo_valor  = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(novo_valor); //funciona para numeros
                taxa_salvar = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(taxa_salvar); //funciona para numeros

                let retorno = {
                    'total' : novo_valor,
                    'taxa'  : taxa_salvar
                }

                return retorno

                }

        },

        async consultar_pix(item, id_pix, link, token){

            if (this.config_emp.PIX_SITUACAO == 'TESTE'){
                token = this.config_emp.PIX_TOKEN_TESTE
            }
            else if (this.config_emp.PIX_SITUACAO == 'PRODUÇÃO'){
                token = this.config_emp.PIX_TOKEN
            }

            link = this.config_emp.PIX_LINK

            id_pix = item.PIX_ID

            link = link+'/'+id_pix

            const header =   {
                 headers: {
                    // 'Content-Type': 'multipart/form-data'
                    // 'Authorization': `Basic ${token}`
                    'Authorization': `Bearer ${token}`
                }
            }

            const res = await axios.get(link, header)
            console.log(res.data);

            if (res.data.status == 'approved'){

                console.log('today:'+ this.today);

                let data_pago       = (res.data.date_last_updated) ? res.data.date_last_updated : this.today
                let valor_pago      = (res.data.transaction_amount) ? res.data.transaction_amount : 0
                let valor_taxas     = (res.data.fee_details.length>0) ? res.data.fee_details[0].amount : 0
                let valor_recebido  = (res.data.transaction_details.net_received_amount) ? res.data.transaction_details.net_received_amount : 0
                
                data_pago =  data_pago.substring(0,10)//copia somente a data.. sem a hora 
                
                console.log('vl pago:'+valor_pago);
                console.log('vl taxa:'+valor_taxas);
                console.log('vl recebido:'+valor_recebido);
                console.log('data pago:'+data_pago);
                // pagamento ok

                let sql = `update conta set 
                       pago = 'S', 
                       data_efetuado = '${data_pago}',
                       double_valor  = '${valor_pago}',
                       double_taxa   = '${valor_taxas}',
                       double_total  = '${valor_recebido}'
                       where codigo  = ${item.CODIGO}`
                
                       console.log(sql);


                await this.crud_sql(sql)
                await this.tabela('conta','update')//refresh
            }
            else {
                if (res.data.status == 'pending'){
                    alert('Pendente')
                }
            }
            

            // console.log(res.data);
            // console.log(res.data.status);
            // alert(res.data.status)
            
        },

        async gerar_varios_pix(){

        },

        async gerar_pix(dados_parcela, dados_aluno, link, token){


            //pega o id do aluno no asaas
            let id_aluno = await this.pix_id_aluno(link, token, dados_aluno)
            if(!id_aluno){
                alert('Não foi possível Buscar ou Cadastrar id_aluno!')
                return false
            }
            else{
                // alert('id_aluno: ' + id_aluno)
            }

            
    
            // return false

            //FAÇO ALGUMAS VERIFICAÇÕES ANTES
            let url         = link + 'payments'
            let juros_mes   = this.strtofloat(this.config_emp.JUROS)
            let multa       = this.config_emp.MULTA || 0

            if (juros_mes>0){ juros_mes =  juros_mes * 30}
            else{ juros_mes = 0 }


            if (this.today > dados_parcela.DATA_VENCIMENTO){
                alert('Esta parcela já esta Vencida.\nAltere a Data do Vencimento!')
                return false
            }

            // return false

            // ENVIO OS CAMPOS NECESSARIOS
            let body  =
                {
                    // billingType         : 'UNDEFINED',
                    billingType         : 'BOLETO',
                    customer            : id_aluno,
                    value               : dados_parcela.double_TOTAL,
                    dueDate             : dados_parcela.DATA_VENCIMENTO,
                    description         : dados_parcela.PLANO+` (${dados_parcela.CODIGO}) ` +  dados_parcela.SERVICO_REFERENTE,
                    externalReference   : dados_aluno.CODIGO_ALUNO,
                    fine                : { value: multa },
                    interest            : { value: juros_mes },
                    postalService       : false
                }

                // this.config_emp
            let retorno = await DSiAsaas.sendGetAxios('POST', url, token, body)
            console.log('retorno::', retorno);

            if (retorno.id){
                // alert('Cobrança Gerada com Sucesso!'+retorno.id)


                // let pagina_retorno = retorno.point_of_interaction.transaction_data.ticket_url
                let pagina_retorno = retorno.invoiceUrl
                let id_pagamento   = retorno.id

                let sql = `update conta set 
                        pix_id       = '${id_pagamento}', 
                        pix_gerado   = '${this.today}',
                        pix_url      = '${pagina_retorno}'
                        where codigo =  ${dados_parcela.CODIGO}`
                console.log(sql);

                this.crud_sql(sql)

                return retorno

            }
            else{
                alert('Não foi possível Gerar a Fatura!')
            }


            
        },

        mudaVias(vias){
            
            this.objVias = []//limpa

            let obj = {}
            for (let i = 1; i <=vias; i++){
                this.$set(obj, 'n',i)
                this.objVias.push(obj)
            }
        },

        async carrega_dados(){

          this.urlLogo =  sessionStorage['emp_url_logo']

          this.$set(this.emp, 'nome',        sessionStorage.getItem('emp_nome'))
          this.$set(this.emp, 'razao',       sessionStorage.getItem('emp_razao'))
          this.$set(this.emp, 'fone1',       sessionStorage.getItem('emp_fone1'))
          this.$set(this.emp, 'fone2',       sessionStorage.getItem('emp_fone2'))
          this.$set(this.emp, 'celular',     sessionStorage.getItem('emp_celular'))
          this.$set(this.emp, 'cnpj',        sessionStorage.getItem('emp_cnpj'))
          this.$set(this.emp, 'cep',         sessionStorage.getItem('emp_cep'))
          this.$set(this.emp, 'endereco',    sessionStorage.getItem('emp_endereco'))
          this.$set(this.emp, 'cidade',      sessionStorage.getItem('emp_cidade'))
          this.$set(this.emp, 'uf',          sessionStorage.getItem('emp_uf'))
          this.$set(this.emp, 'email',       sessionStorage.getItem('emp_email'))

        

          //   ARRAY TO OBJECT
        //   let aa = []
        //   aa = await this.crud_empresa()
        //   this.config_emp = await aa[0]

          try { this.obj_dados_empresa = JSON.parse(sessionStorage['obj_dados_empresa']) }
          catch (error) { console.log('erro:', error); }

          try { this.config_emp = JSON.parse(sessionStorage['config_emp']) }
          catch (e) {}

          try { this.config_pix = JSON.parse(sessionStorage['config_pix']) }
          catch (e) {}
          
          
        //   @rex
          this.podeFaturar = (this.config_pix) ? true : false

          try {this.obj_dados_cliente = JSON.parse(sessionStorage['obj_dados_cliente'])}
          catch (error) { }


          try{
              this.meia_folha = JSON.parse(localStorage['ls_meia_folha']) 
          }catch(e){ this.meia_folha = true}

          this.palmas_araucaria = await DSibasico.esta_empresa('araucária','palmas')


          this.etapa_novo = 0
          try{
              this.etapa_novo = sessionStorage['etapa_novo']
          }catch(e){ this.etapa_novo = 0 }


        //   if (this.etapa_novo == 4){
        //      alert('Agora é só imprimir o Recibo da entrada, caso ')
        //      console.log('items_parcelas:', this.items_parcelas);
             
        //     //  sessionStorage['etapa_novo'] = 0
        //   }

          if (this.etapa_novo == 3){
             if (confirm(`Deseja Adicionar o Plano de Pagamento?`)){
                this.etapa_novo = 4
                this.mais_parcelas('E')
             }else{
                 this.etapa_novo = 0
             }
          }else{
             this.etapa_novo = 0
          }

          sessionStorage['etapa_novo'] = this.etapa_novo
          
          
        },

        seleciona_linha(row) {
        //   console.log(row);
        //    this.selected= [{"CODIGO" : row.CODIGO}] //via v-modal no data-table

        //    this.item_menu = row

            if (this.selected?.length <= 1){

                this.selected  = [ Object.assign({}, row)] 

                this.obj_clicado = Object.assign({}, row)
            }
        },

        rightClick(event, item) {
          // console.log(event)
          // console.log(item)

          this.abre_menu(item.item)
          event.preventDefault()
        },

        async excluir_todas_parcelas(item){

            // console.log(item);console.log(this.pro_dados_servico.X_SOMAS[0].SUM_TOTAL);return false


            let total = this.pro_dados_servico.X_SOMAS[0].SUM_TOTAL
            // let sql = 'delete from conta  where CODIGO_SERVICO = '+ item.CODIGO_SERVICO
            let sql = `update conta set conta.ativo = 'X', conta.DATA_EXCLUSAO = CURDATE()  where CODIGO_SERVICO = `+ item.CODIGO_SERVICO
            // console.log(sql);

            if (confirm("Deseja realmente EXCLUIR TODAS as Parcelas ??")){
                

                if (!confirm("ATENÇÃO!!! Deseja realmente EXCLUIR TODAS as Parcelas ??")){
                    return false
                }


                await this.crud_sql(sql)
        
                await this.tabela('conta','update')//refresh

                await registra_log('FINANCEIRO', negritoO('EXCLUIU TODAS','red') + ` as PARCELAS (R$ ${total}) de ${this.pro_dados_aluno.NOME}:${this.pro_dados_aluno.CODIGO_ALUNO} de
                                     ${this.pro_dados_servico.DESCRICAO} Nº${this.pro_dados_servico.CODIGO}`, this.pro_dados_aluno.CODIGO_ALUNO, -86)

                this.selected = []//limpa selecao
            }

        },

        async go_all_excluir_parcelas(){

            alert('Parcelas Pagas não serão excluídas. É necessário Estornar antes!')

            let tipo  = ''
            let valor = ''
            let vence = ''

            if (confirm(`Deseja realmente Excluir (${this.selected.length}) Parcelas Selecionadas ?`)){
          

                let qt = this.selected.length
                for (let i = 0; i < qt; i++){

                    tipo  = this.selected[i].TIPO
                    valor = this.selected[i].double_VALOR
                    vence = this.selected[i].x_DATA_VENCIMENTO
                    
                    if (tipo == 'E'){ tipo = 'ENTRADA' } else { tipo = 'SAIDA' }
                    // console.log('deletar: '+ this.selected[i].CODIGO);

                    if (this.selected[i].PAGO == 'N'){
                        // let sql = `delete from conta  where CODIGO = ${this.selected[i].CODIGO}  and PAGO = 'N'`
                        let sql = `update conta set conta.ativo = 'X', conta.DATA_EXCLUSAO = CURDATE()  where CODIGO = ${this.selected[i].CODIGO}  and PAGO = 'N'`
                        // console.log(sql);
                        this.crud_sql(sql)

                        await registra_log('FINANCEIRO', negritoO('EXCLUIU SELECIONADO','red') + ` ${tipo} Nº${this.selected[i].CODIGO} (R$ ${valor}) VENC.${vence} de ${this.pro_dados_aluno.NOME}:${this.pro_dados_aluno.CODIGO_ALUNO} de
                        ${this.pro_dados_servico.DESCRICAO} Nº${this.pro_dados_servico.CODIGO}`, this.pro_dados_aluno.CODIGO_ALUNO, this.selected[i].CODIGO)
                    }
                    else{
                        alert(`Parcela ${this.selected[i].CODIGO} não foi excluída pois ja esta PAGA!`)
                    }
                }


                setTimeout(function(){
                    this.tabela('conta','update')//refresh

                    this.selected = []//limpa selecao

                }.bind(this), 555);

                this.dialog_menu = false
            }

        },



        async imprimir(item){

            
            // alert(this.modelo_impressao)

            if (this.modelo_impressao == 'RECIBO'){
                let resp = await this.RECIBO_SALVA()

                if (!resp){
                    return false 
                }
            }

           

            // console.log('item::::', item);
            await registra_log('FINANCEIRO', negritoO('IMPRIMIU RECIBO','blue') + ` Nº${item?.CODIGO} `+ negritoO(`(${item.x_double_TOTAL})`,false) +` de ${this.pro_dados_aluno.NOME}:${this.pro_dados_aluno.CODIGO_ALUNO}`, this.pro_dados_aluno.CODIGO_ALUNO)

            window.scrollTo(0, 0);
            window.print() //subir para nao dar erro de impressao
        },

        close(){
            this.dialog_print = false
        },

        async imprimir_recibo(item, tipo){
           

            this.modelo_impressao = tipo
            // this.item_menu = item
            if (item){

                this.recibo_unico = false
                // busco a sequencia do recibo e add no item
                let seq = await this.RECIBO_SEQUENCIA(item.CODIGO)
                item.SEQUENCIA = seq 

                this.item_menu = await Object.assign({}, item)

                this.obj_dados_recibo = await Object.assign({}, item)


            }


            if (item){
                // define o valor que aparecera no recibo
                // let valor   = this.strtofloat(this.item_menu.double_TOTAL)
                let taxa    = this.strtofloat(this.item_menu.double_TAXA) || 0
                if (taxa > 0){
                    this.valor_recibo = this.item_menu.double_VALOR //SE TIVER TAXA PEGA O VALOR ORIGINAL    
                }
                else{
                    this.valor_recibo = this.item_menu.double_TOTAL//senao pega o valor total pago
                }
            }

            this.dialog_print = true

            this.mudaVias(this.nVias)

            // console.log('imprimir_recibo:');
            // console.log(item); 
            // console.log('pro_dados_aluno:');
            // console.log(this.pro_dados_aluno);
        },

        abre_menu(item){
            // console.log('5 abre_menu:', item);

            this.dialog_menu = true
            // this.item_menu = item
            this.item_menu = Object.assign({}, item)

            this.$set(this.item_menu   , 'X_NOME', this.pro_dados_aluno.NOME )//ADICONO NOME NO CAMPO CALCULADO


            this.seleciona_linha(item)
        },

        mesmo_valor(){
            if (this.checkbox_parcial){
                this.total_recebido     = null //this.edita_parcelas.double_TOTAL
                this.prorrogar_parcial  = 30 //dias 
            }
            else{
                this.total_recebido = this.edita_parcelas.double_TOTAL
            }
        },

        async efetuar(){
            
            this.data_hora_agora()

            let T = this.strtofloat(this.edita_copia.double_TOTAL)            
            let P = this.strtofloat(this.total_recebido)
            let R = 0
            R = T - P
            
            let dias = parseInt( this.prorrogar_parcial)//converte string to integer
            let plano = this.edita_parcelas.PLANO

            // alert(this.total_recebido)
            // return 'exit'

            if (R>0){//parcial entao zera juros e multa e coloca o valor = valor recebido..
              this.$set(this.edita_parcelas , 'double_VALOR', this.total_recebido )
              this.$set(this.edita_parcelas, 'double_JUROS', 0 )
              this.$set(this.edita_parcelas, 'double_TAXA', 0 )
            }
            else{
                this.$set(this.edita_parcelas, 'double_JUROS', this.edita_copia.double_JUROS )
                this.$set(this.edita_parcelas, 'double_TAXA', this.edita_copia.double_TAXA )
            }
            this.$set(this.edita_parcelas , 'double_TOTAL', this.total_recebido )
            

            this.$set(this.edita_parcelas , 'PAGO', 'S' )
            this.$set(this.edita_parcelas , 'QUEM_EFETUOU'         , this.quem_alterou )
            this.$set(this.edita_parcelas , 'QUEM_EFETUOU_CODIGO'  , this.obj_user.CODIGO )
            this.$set(this.edita_parcelas , 'QUEM_ALTEROU'         , this.quem_alterou )
            

            if (R>0){//parcial
              this.$set(this.edita_parcelas, 'PLANO',  plano+'¹')
            }


            //copia para imprimir, imprimo aqui no final
            this.obj_imprimir = Object.assign({}, this.edita_parcelas)
            

            this.salvar_tabela('conta', this.edita_parcelas,'dialog_efetuar', this.item_menu)

            //gera parcela parcial
            if ( (this.checkbox_parcial) && (R>0) ) {

                this.edita_parcelas = this.edita_copia//copio os dados originais

                //altero alguns dados
                R = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(R); //funciona para numeros
                this.$set(this.edita_parcelas, 'double_VALOR', R )
                this.$set(this.edita_parcelas, 'double_TOTAL', R )
                this.$set(this.edita_parcelas, 'double_JUROS', 0 )
                this.$set(this.edita_parcelas, 'double_TAXA', 0 )

                this.$set(this.edita_parcelas, 'PLANO', plano+'²')

                this.$set(this.edita_parcelas, 'CODIGO', 0 )
                this.$set(this.edita_parcelas, 'DATA_VENCIMENTO', this.incDay(this.today, dias,'us') )
                // this.$set(this.edita_parcelas, 'DATA_VENCIMENTO', '2022-12-12' )



                await this.tabela_create('conta', this.edita_parcelas)
            }


            // if (this.checkbox_recibo){
            //     await this.imprimir_recibo(this.obj_imprimir, 'RECIBO')
            // }

            //atualiza o selected atualiza a selecao
            if (Object.keys(this.obj_recibo_unico).length === 0){
                setTimeout(async () => {
                   await this.atualizaSelecao('items_parcelas');
                }, 333);
            }


            // imprime depois de atualizar os juros
            setTimeout(async () => {
            if (this.checkbox_recibo){
                await this.imprimir_recibo(this.obj_imprimir, 'RECIBO')
            }
            }, 999);

        },

        estornar(item){

            if (confirm("Deseja realmente Estornar o código  "+item.CODIGO+' - R$ '+item.double_TOTAL+' ?')){

                this.data_hora_agora()

                let item_menu_here   = Object.assign({}, item)//copio para nao alterar o original

                item_menu_here.PAGO                   = 'N'
                item_menu_here.DATA_EFETUADO          = '0000-00-00'
                item_menu_here.QUEM_EFETUOU           = ''
                item_menu_here.QUEM_EFETUOU_CODIGO    = 0
                item_menu_here.QUEM_ALTEROU           = this.quem_alterou

                this.salvar_tabela('conta', item_menu_here,'', this.item_menu)


                //atualiza o selected atualiza a selecao
                if (Object.keys(this.obj_recibo_unico).length === 0){
                    setTimeout(async () => {
                    await this.atualizaSelecao('items_parcelas');
                    }, 999);
                }
            }
        },

        abre_efetuar(item){

        //    this.item_menu = item
           this.item_menu = Object.assign({}, item)

           this.checkbox_parcial = false 
           this.checkbox_juros = (this.strtofloat(item.double_JUROS)>0)

           this.editar_tabela(item, 'edita_parcelas', 'dialog_efetuar')

           //definindo alguns valores 
           this.total_recebido          = item.double_TOTAL
           this.edita_parcelas.DATA_EFETUADO   = this.today

           //faço uma copia em caso de parcial
        //    this.edita_copia = item

           //copiando objetos 
           this.edita_copia = Object.assign({}, item)
           this.obj_valores = Object.assign({}, item)


        },

        manda_emit(acao,a,b,c){
            this.$emit('emit_executa',acao,a,b,c)//mando atualizar as somas 
            this.dialog_ad_exame = false
        }, 



        digitou_servico(event){

            // console.log(event);
            // console.log('combobox_servico:', this.combobox_servico);
            let valor_digitou = event.target._value

            // console.log('event.target._value:', event.target._value);
            // console.log('valor_digitou:', valor_digitou);



            // limpa o timer, reseta
            clearTimeout(this.timer_digitou_servico);
            
            this.timer_digitou_servico = 
                setTimeout(function(){
                
                    console.log('timer_digitou_servico:');
                    this.seleciona_servico(valor_digitou)
                
                }.bind(this), 333);//1100
        },
        

        seleciona_servico(item){
            // console.log('seleciona_servico:', item);
            // console.log(this.edita_servico);
            // console.log('item:', item);


            if(item){
                //verifica se é um objeto e tem uma determinada propriedade    
                if (item.hasOwnProperty('double_TOTAL')){
                    //É UM OBJETO
                    this.$set(this.edita_gerar_parcelas, 'TOTAL', item.double_TOTAL)
                    this.$set(this.edita_gerar_parcelas, 'SERVICO_REFERENTE', item.DESCRICAO)
                }else{
                    //NÃO É UM OBJETO
                    //default
                    this.$set(this.edita_gerar_parcelas, 'TOTAL', '')
                    this.$set(this.edita_gerar_parcelas, 'SERVICO_REFERENTE', item.toUpperCase())
                    // a = a.toUpperCase();
                }
            }
            else{
                this.$set(this.edita_gerar_parcelas, 'TOTAL', '')
                this.$set(this.edita_gerar_parcelas, 'SERVICO_REFERENTE', '')
            }
        },


        //---------------importando funcoes basicas ----------------------- INICIO
        
        firstUpper(event, field){
            // console.log(event);
            let a = event.target.value;//captura o valor do event

            if (a!=='' && a.length==1){  
            a = a.toUpperCase();
            // this.item_edita[field] = a;

            event.target.value = a
            } 
        },

        moeda(event){
            return DSibasico.moeda(event)
        },

        allUpper(event, obj_name, field){
            this[obj_name][field] = DSibasico.allUpper(event, obj_name, field)
        },

        async data_hora_agora(){
        // define_data_hora(){
            DSibasico.define_data_hora(this)//passo o this para que la ele defina as variaveis daqui
        },

        incMonth(data,meses,pt){
            return DSibasico.incMonth(data,meses,pt)
        },

        incDay(data,dias,pt){
            return DSibasico.incDay(data,dias,pt)
        },

        strtofloat(vem){
            return DSibasico.strtofloat(vem)
        },

        floatTostring(vem){
            return DSibasico.floatTostring(vem)
        },

        floatTostring2(vem){
            return DSibasico.floatTostring2(vem)
        },

        getFormatDate(data){
            return DSibasico.getFormatDate(data)
        },

        getFormatCurrency(v,string){
          return DSibasico.getFormatCurrency(v, string)
        },

        alerta(text,color){
            DSibasico.alerta(this, text, color)
        },

        //---------------importando funcoes basicas ----------------------- FIM



        //---------------importando funcoes sql ----------------------- INICIO

        //FICA NO BOTAO SALVAR.. VERIFICA SE UPDATE OU CREATE
        async salvar_tabela(tabela, obj_edita, dialog_name, obj_before){

            let before  = Object.assign({}, obj_before);//faço uma copia do original
            return await DSisql.salvar_tabela(this,tabela, obj_edita, dialog_name, before)
        },

        async tabela_update(tabela, obj_edita, obj_before){
            let r =   await DSisql.tabela_update(this, tabela, obj_edita, obj_before)
            this.manda_emit('update_somas', this.checkbox_so_entradas)

            return r
        },

        async tabela_create_no_refresh(tabela, obj_edita){
            // console.log('tabela_creat:',obj_edita);
            await DSisql.tabela_create_no_refresh(this, tabela, obj_edita)
            this.manda_emit('update_somas', this.checkbox_so_entradas)
        },

        async tabela_create(tabela, obj_edita){
            // console.log('tabela_creat:',obj_edita);
            let r = await DSisql.tabela_create(this, tabela, obj_edita)
            this.manda_emit('update_somas', this.checkbox_so_entradas)
            
            return r
        },

        //EXECUTAR UM SQL TIPO UPDATE
        async crud_sql (sql) {
            let r = await DSisql.crud_sql(this, sql)
            this.manda_emit('update_somas', this.checkbox_so_entradas)

            return r
        },

        //ABRE OS DADOS DA TABELA
        async crud_abrir_tabela(sql, items_name){
           return  await DSisql.crud_abrir_tabela(this, sql, items_name)
        }, 

        editar_tabela(item, obj_edita_name, dialog_name) {

            if (obj_edita_name == 'edita_parcelas'){
                if (item.PAGO=='S'){
                    if (!confirm(`Este Lançamento ja foi Efetuado (PAGO). Deseja continuar?`)){
                        return false
                    }
                }
            }

            DSisql.editar_tabela(this, item, obj_edita_name, dialog_name)
        },
        
        async remover_tabela(tabela, obj_edita, titulo){
           await DSisql.remover_tabela(this, tabela, obj_edita, titulo)
        },


        //---------------importando funcoes sql ----------------------- FIM



        open_tabela_contas(){
            let sql = 'select * from tabela_contas'
            this.crud_abrir_tabela(sql, 'items_tabela_contas' )
        },

        open_tabela_formas(){
            let sql = 'select DESCRICAO from tabela_formas order by DESCRICAO'
            this.crud_abrir_tabela(sql, 'items_tabela_formas' )
        },


        async tabela(tabela,acao){
            this.tabela_selecionada = tabela
            // this.card_titulo = item.text

            if (tabela=='conta'){
                if ( (acao == 'create') || (acao == 'delete') || (acao == 'update') ){
                   await this.abrir_parcelas(this.pro_ide,this.pro_cod_servico)
                }
            }
        },


        refresh(){

            this.data_hora_agora()
            // this.define_data_hora()
            this.open_tabela_contas()
            this.open_tabela_formas()
            this.abrir_parcelas(this.pro_ide,this.pro_cod_servico)

            // this.abrir_parcelas(this.ide,this.cod_servico)

            // if (this.pro_dados_servico.SITUACAO !== 'ATIVO'){
            if (!['ATIVO','APROPRIADO','PRE-CADASTRO'].includes(this.pro_dados_servico.SITUACAO)){
                //this.permissoes.gerarparcelas = false desativei isso 
            }

            // console.log('pro_dados_aluno');
            // console.log(this.pro_dados_aluno);

            // console.log('pro_dados_servico');
            // console.log(this.pro_dados_servico);
        },

        seleciona_conta_referente(){

            let CODIGO =  this.edita_parcelas.CODIGO_CONTA.CODIGO
            let DESCRICAO =  this.edita_parcelas.CODIGO_CONTA.DESCRICAO
            
            this.$set(this.edita_parcelas, 'CODIGO_CONTA',     CODIGO )
            this.$set(this.edita_parcelas, 'CONTA_REFERENTE', DESCRICAO)
        },

        seleciona_forma_pagamento(){

            // console.log('this.edita_parcelas.FORMA:');
            // console.log(this.edita_parcelas.FORMA);

            // if (0>1){
                // TERMINAR ISSO DAQUI
        
                    // let TAXA    =  this.edita_parcelas.FORMA_PAGAMENTO.double_TAXA
                    // let FORMA   =  this.edita_parcelas.FORMA_PAGAMENTO.DESCRICAO
                    let FORMA   =  this.edita_parcelas.FORMA_PAGAMENTO

                    
                    // this.$set(this.edita_parcelas, 'double_TAXA',     TAXA )
                    this.$set(this.edita_parcelas, 'FORMA_PAGAMENTO', FORMA)

                    // console.log(this.edita_parcelas);
            // }
        },

        digitou_entrada(item) {
            // console.log('item:');
            // console.log(item);

            //procura o valor dentro de um array de objetos
            let tem = this.valores_digitou.find( quero => quero.CODIGO === item.CODIGO )
            if (tem){
            //   console.log('tem:');
            //   console.log(tem);
              //EDITA
              tem.TOTAL = item.TOTAL
            }
            else{
                // console.log('vazio');
                //INSERE    
                //DEFINE OS VALORES DO OBJETO 
                let obj = {
                    "CODIGO" : 0,
                    "TOTAL" : 0,
                }
                this.$set(obj, 'CODIGO',  item.CODIGO)
                this.$set(obj, 'TOTAL',   item.TOTAL)

                this.valores_digitou.push(obj)
            }

            // console.log('valores_digitou:');
            // console.log(this.valores_digitou);
    

            // clear timeout variable
            clearTimeout(this.timer_digitou);
            
            this.timer_digitou = 
                setTimeout(function(){
                
                this.multiplica()
                
                }.bind(this), 1500);//usar esse .bind(this) para chamar funcoes com o setTimeout
        },


        getVencido(hoje, data){

            if (hoje > data ){
                // console.log(hoje +' >venceu '+data);
                return 'orange' //red
            }
            else if (hoje == data ){
                // console.log(hoje +' = '+data);
                return 'orange'
            }
            else{
                // console.log(hoje +' < '+data);
                return 'black'
            }
        },


        async gerar_parcelas(){

            

            let total     = this.strtofloat(this.edita_gerar_parcelas.TOTAL)

            if ((total<=0)){
                alert('Defina um Valor Válido!')
                return false
            }

            this.data_hora_agora()

            this.edita_parcelas = {}//limpa objeto
            

            // console.log('gerar_parcelas - def_parcelas:');
            // console.log(this.def_parcelas); 

            if (this.$refs.form.validate()){

                if ((this.edita_gerar_parcelas.TOTAL<=0)){
                    this.alerta('Defina um Valor Válido!','red')

                    //LIMPO O LOG APOS O EXIT
                    setTimeout(function(){
                        console.clear()
                    }.bind(this), 555)

                    exit
                }


                this.overlay = true

                let q_alterou = ''
                let qt = this.def_parcelas.length
                for (let i = 0; i < qt; i++){
                    
        
                    let dados_servico = this.pro_dados_servico
                    // let dados_parcela = this.def_parcelas[i]
                    let copia = this.def_parcelas.map((x) => x); //clonando array copiar array
                    let dados_parcela = copia[i]
                    // this.items_editaveis = this.items_header.map((x) => x); //clonando array copiar array
                    // let plano = i+1+'/'+qt
                    let plano = i+1+'/'+qt

                    if (this.checkbox_entrada){
                        if (i == 0){
                            plano = '0'
                        }
                        else{
                            plano = i+'/'+(qt-1)
                        }
                    }


                    this.$set(this.edita_parcelas, 'CODIGO_ALUNO',    dados_servico.CODIGO_ALUNO )
                    this.$set(this.edita_parcelas, 'CODIGO_SERVICO',  dados_servico.CODIGO )
                    this.$set(this.edita_parcelas, 'ATIVO',           'S' )
                    this.$set(this.edita_parcelas, 'VENDAS_DRE',      'S' )

                    this.$set(this.edita_parcelas, 'DATA_VENDA',          this.today )
                    this.$set(this.edita_parcelas, 'DATA_VENCIMENTO',     dados_parcela.DATA_VENCIMENTO )
                    this.$set(this.edita_parcelas, 'DATA_EFETUADO',       dados_parcela.DATA_EFETUADO )
                    if( (dados_parcela.DATA_EFETUADO == '') || (dados_parcela.DATA_EFETUADO == null)){
                        this.$set(this.edita_parcelas, 'PAGO'               , 'N' )
                        this.$set(this.edita_parcelas ,'QUEM_EFETUOU'       , '' )
                        this.$set(this.edita_parcelas ,'QUEM_EFETUOU_CODIGO', 0 )
                    }else{
                        this.$set(this.edita_parcelas, 'PAGO'               , 'S' )
                        this.$set(this.edita_parcelas ,'QUEM_EFETUOU'       , this.quem_alterou )
                        this.$set(this.edita_parcelas ,'QUEM_EFETUOU_CODIGO', this.obj_user.CODIGO )
                    }

                    this.$set(this.edita_parcelas, 'double_VALOR',       dados_parcela.TOTAL )
                    this.$set(this.edita_parcelas, 'double_JUROS',       0 )
                    // this.$set(this.edita_parcelas, 'double_TAXA',       0 )
                    this.$set(this.edita_parcelas, 'double_TOTAL',       dados_parcela.TOTAL )
                    this.$set(this.edita_parcelas, 'SERVICO_REFERENTE',  dados_parcela.SERVICO_REFERENTE )
                    this.$set(this.edita_parcelas, 'OBSERVACAO',         '' )
                    // this.$set(this.edita_parcelas, 'OBSERVACAO',         this.pro_dados_aluno.NOME )
                    // this.$set(this.edita_parcelas, 'FORMA_PAGAMENTO',    dados_parcela.FORMA.DESCRICAO )
                    this.$set(this.edita_parcelas, 'FORMA_PAGAMENTO',    dados_parcela.FORMA )


                    this.$set(this.edita_parcelas, 'CODIGO_CONTA',       this.edita_gerar_parcelas.CODIGO_CONTA.CODIGO)
                    this.$set(this.edita_parcelas, 'CONTA_REFERENTE',   this.edita_gerar_parcelas.CODIGO_CONTA.DESCRICAO)

                    this.$set(this.edita_parcelas, 'COBRAR_JUROS',   this.edita_gerar_parcelas.COBRAR_JUROS)
                    

                    //DEFAULT
                    this.$set(this.edita_parcelas, 'VISTO',          'N' )
                    
                    this.$set(this.edita_parcelas, 'TIPO',           this.edita_gerar_parcelas.TIPO )
                    if (this.edita_gerar_parcelas.TIPO == 'E'){
                        this.$set(this.edita_parcelas, 'CATEGORIA'  ,    'RECEBIMENTO' )
                    }else{
                        this.$set(this.edita_parcelas, 'CATEGORIA'  ,    dados_parcela.SERVICO_REFERENTE  )
                    }

                    this.$set(this.edita_parcelas, 'PLANO'  ,         plano)

                    q_alterou = this.quem_alterou
                    this.$set(this.edita_parcelas, 'QUEM_ALTEROU'  , q_alterou )

                    
                    // console.log('edita_parcelas:', this.edita_parcelas);
                    // alert(this.edita_parcelas.double_TOTAL)

                   await this.tabela_create_no_refresh('conta', this.edita_parcelas)

                //    await this.tabela_create('conta', this.edita_parcelas)//metodo antigo..ficava atualiznado...
                }


                await this.tabela('conta','create')//close open
                // await this.tabela('conta','update')//refresh

                // alert(qt)
                let ss = ``
                if (this.edita_gerar_parcelas.TIPO == 'E'){ 
                    if (qt == 1){
                        ss = negritoO('ADICIONOU PARCELA', 'blue') + ' de '
                    }
                    else{
                        ss = negritoO('GEROU PARCELAS', 'blue') + ' de '
                    }
                }
                else { 
                    ss = negritoO('PAGOU', 'red')
                 }

                

                await registra_log('FINANCEIRO', `${ss}  (R$ ${negritoO(this.edita_gerar_parcelas.TOTAL)} em ${qt}x) de ${this.pro_dados_aluno.NOME}:${this.pro_dados_aluno.CODIGO_ALUNO} - ${negritoO(this.edita_gerar_parcelas.SERVICO_REFERENTE)} Sº${this.pro_dados_servico.CODIGO}`, this.pro_dados_aluno.CODIGO_ALUNO)
                // await registra_log('FINANCEIRO', `${ss}  (R$ ${negritoO(this.edita_gerar_parcelas.TOTAL)} em ${qt}x) de ${this.pro_dados_aluno.NOME}:${this.pro_dados_aluno.CODIGO_ALUNO} - ${this.pro_dados_servico.DESCRICAO} Nº${this.pro_dados_servico.CODIGO}`, this.pro_dados_aluno.CODIGO_ALUNO)
                // await registra_log('FINANCEIRO', `${(qt == 1 ? negritoO('ADICIONOU PARCELA','blue') : negritoO('GEROU PARCELAS','blue'))}  de  (R$ ${this.edita_gerar_parcelas.TOTAL} em ${qt}x) de ${this.pro_dados_aluno.NOME}:${this.pro_dados_aluno.CODIGO_ALUNO} - ${this.pro_dados_servico.DESCRICAO} Nº${this.pro_dados_servico.CODIGO}`, this.pro_dados_aluno.CODIGO_ALUNO)

                this.overlay = false
                this.dialog_gerar_parcela=false


                // console.log('items_parcelas:', this.items_parcelas);//aqui ele ja esta atualiado, ja tem os codigos
                
                // pergunta se quer imprimir, passa qt de parcelas geradas, e se for 1 passa quem alterou pra buscar o codigo
                await this.go_imprimir_recibo(this.items_parcelas, qt, q_alterou)
                
                

            }else{
                this.alerta('Preencha os campos necessários!','red')
            }
        },

        async multiplica(){

            if (!this.dialog_gerar_parcela){
                return false 
            }




            // // caso seja chemin ele calcula a data de outra forma
            if (await DSibasico.esta_empresa('chemin')) {

                
                this.data_chemin = await this.calcularDataVencimento(this.today)

                if (this.checkbox_entrada){
                    this.$set(this.edita_gerar_parcelas, 'DATA_VENCIMENTO', this.incMonth(this.data_chemin,-1,'us'))//pego data chemin - 1 mes..
                }else{
                    this.$set(this.edita_gerar_parcelas, 'DATA_VENCIMENTO', this.data_chemin)
                }
            }

            
            let qt   = this.edita_gerar_parcelas.PARCELAS
            let item = this.edita_gerar_parcelas
            
            // console.log('edita_gerar_parcelas:');
            // console.log(item); 
            
            // console.log('this.def_parcelas:');
            // console.log(this.def_parcelas);
            
            this.def_parcelas = []//limpa obj
            for (var member in this.def_parcelas)  this.def_parcelas[member]= ''; //limpando os campos do objeto 
            
            // console.log(this.def_parcelas);

            let B =  this.strtofloat(item.TOTAL)//PEGANDO VALOR TOTAL

            let TOTAL = this.strtofloat(item.TOTAL)//PEGANDO VALOR TOTAL
            // console.log('TOTAL:'+TOTAL);
            // console.log(item.TOTAL);


            let entrada = 0
            this.inicio = 0
            let inicio2 = 1
            if (this.checkbox_entrada){
                this.inicio = 1 
                inicio2 = 0
            }


            //CALCULA O VALOR DIVIDIDO
            let entrada_string = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(entrada); //funciona para numeros
            
            let V = parseInt(qt)+ parseInt(this.inicio)   
            let vezes = V
            // console.log('vezes:'+vezes);
            // console.log('V:'+V);

            let SOMA = 0
            let ULTIMO = 0
            let erro = false

            let obj = null
            for (let i = (1-this.inicio); i <= qt; i++) { //PERCORRE E PREENCHE ARRAY DE OBJETO

                // console.log('vezes:'+vezes);
                
                if (this.multi){
                    B = TOTAL
                }else{
                    B = (TOTAL - SOMA) / vezes
                }
                
                ULTIMO = B //ultmo valor digitado..
                // console.log('...............');
                // console.log('TOTAL - SOMA / VEZES:');
                // console.log(TOTAL +' - '+SOMA +'/'+ vezes + ' = '+B);
                // console.log('ULTIMO:'+ULTIMO);
                
                
                //procura o valor dentro de um array de objetos
                let tem = this.valores_digitou.find( quero => quero.CODIGO === i )
                if (tem){
                    //   B = (tem.TOTAL)//pega valor digitado
                    B = this.strtofloat(tem.TOTAL)//pega valor digitado
                    if (B==''){
                        B = 0
                    }
                    //   console.log('ACHOU B:'+B)
                }

                // console.log('B:'+B);
                if  ( parseFloat(B) > (vezes * ULTIMO)) {
                    erro = true
                }
                if  ( parseFloat(B) == (vezes * ULTIMO)) {
                    if (vezes>1){
                    erro = true
                    }
                }
                if ( ( parseFloat(B) == 0 ) || (TOTAL == SOMA) ) {
                    erro =  true
                }
                if ( (vezes==1) && (B<ULTIMO) ){
                    erro = true
                }
                if (erro){
                    // console.log('volta ao ultimo:'+vezes);
                    this.alerta('Ajustando Valores!','orange')
                    B = ULTIMO
                }


                if ((tem) && (erro)){            
                    tem.CODIGO = null //pega valor digitado
                    console.log('ERRO ENTAO LIMPANDO')
                }
                
                
                SOMA += parseFloat(B) //soma o valor que ja foi definido
                vezes -= 1


                //formato 
                // B = B.toLocaleString('pt-br',{ minimumFractionDigits: 2, maximumFractionDigits: 2 });//funciona pra string
                B = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(B); //funciona para numeros

            

                //DEFINE OS VALORES DO OBJETO
                obj = {
                    "CODIGO" : i,
                    "TOTAL"  : B,
                    "FORMA"  : item.FORMA,
                    "TIPO"   : item.TIPO,
                    // "FORMA":{
                    //     "CODIGO"      :item.FORMA.CODIGO,
                    //     "DESCRICAO"   :item.FORMA.DESCRICAO,
                    //     "double_TAXA" :item.FORMA.double_TAXA,
                    //     "TIPO_TAXA"   :item.FORMA.TIPO_TAXA,
                    // },
                    "DATA_VENCIMENTO"  : this.incMonth(item.DATA_VENCIMENTO,i - inicio2,'us'),
                    "DATA_EFETUADO"   : '',
                    "SERVICO_REFERENTE"   : item.SERVICO_REFERENTE
                }

                //ALGUMAS VERIFICACOES 
                if (item.EFETUAR == 'HOJE'){
                     this.$set(obj, 'DATA_EFETUADO',  this.today)
                }
                else if (item.EFETUAR == 'NO VENCIMENTO'){     
                    this.$set(obj, 'DATA_EFETUADO',  this.incMonth(item.DATA_VENCIMENTO,i - inicio2,'us'))
                    //  this.$set(obj, 'DATA_EFETUADO',  this.incMonth(item.DATA_VENCIMENTO,i,'us'))
                }

                
                //entrada
                if ( (i== (1-this.inicio)) && (V>0) ){
                     if (this.checkbox_entrada){
                        
                        // this.$set(obj, 'DATA_EFETUADO',  item.DATA_VENCIMENTO)

                        if  (await DSibasico.esta_empresa('chemin')) {
                            this.$set(obj, 'DATA_VENCIMENTO' ,  this.today)
                            this.$set(obj, 'DATA_EFETUADO'   ,  this.today)
                        }
                        else{
                            this.$set(obj, 'DATA_EFETUADO',  item.DATA_VENCIMENTO)
                        }
                        
                     }

                     if (entrada>0){
                        this.$set(obj, 'TOTAL',  entrada_string)
                     }
                }

                //INSERE NO ARRAY OS OBJETOS
                this.def_parcelas.push(obj)
            }

            // console.log('obj:', obj);
            // console.log('def_parcelas:', this.def_parcelas);
        },

        async mais_parcelas(tipo){
        // console.log('mais_parcelas:');
        // console.log(this.pro_dados_servico);

        this.multi = false 

        this.valores_digitou = []//limpa array 


        for (var member in this.edita_gerar_parcelas)  this.edita_gerar_parcelas[member]= ''; //limpando os campos do objeto 
        
        // this.$set(this.edita_gerar_parcelas, 'FORMA',              'DINHEIRO'  )
        // this.$set(this.edita_gerar_parcelas, 'FORMA',              'DINHEIRO  )
        this.$set(this.edita_gerar_parcelas, 'DATA_VENCIMENTO',    this.today  )


        this.$set(this.edita_gerar_parcelas, 'TIPO',               tipo  )
        this.$set(this.edita_gerar_parcelas, 'COBRAR_JUROS',       (this.showJuros) ? '1' : ''  )
        this.$set(this.edita_gerar_parcelas, 'PARCELAS',           '1'  )
        this.$set(this.edita_gerar_parcelas, 'CODIGO_SERVICO',     this.pro_dados_servico.CODIGO  )
        this.$set(this.edita_gerar_parcelas, 'CODIGO_CLIENTE',     this.pro_dados_servico.CODIGO_ALUNO )
        this.$set(this.edita_gerar_parcelas, 'CODIGO_CONTA',       {CODIGO:'1', DESCRICAO:'CFC'}  )



        if (tipo == 'S'){
            this.$set(this.edita_gerar_parcelas, 'TOTAL',     '' )
            this.$set(this.edita_gerar_parcelas, 'EFETUAR',   'HOJE')
            this.checkbox_entrada = false
        }
        else if (this.primeira_parcela){

            this.checkbox_entrada = true
            this.$set(this.edita_gerar_parcelas, 'EFETUAR',              'PENDENTE'  )
            this.$set(this.edita_gerar_parcelas, 'TOTAL',                this.pro_dados_servico.double_TOTAL  )
            this.$set(this.edita_gerar_parcelas, 'SERVICO_REFERENTE',    this.pro_dados_servico.DESCRICAO  )

        }else{
            this.$set(this.edita_gerar_parcelas, 'EFETUAR',   'HOJE'  )
            // this.$set(this.edita_gerar_parcelas, 'TOTAL',     '0'  )
        }
        

        // CARREGO DA LISTA DE SERVIÇOS
        this.combobox_servico = null//deixo como null pois estou usando ele tanto commo objeto quanto texto..
        // let sql = "select * from tabela_servicos order by nivel"
        // let sql = "select * from tabela_servicos where nivel <> 'PRIMARIO' order by nivel"
        let sql = "select * from tabela_servicos order by nivel"
        this.crud_abrir_tabela(sql, 'items_tabela_servico' )


        setTimeout(function(){
            this.dialog_gerar_parcela = true
        }.bind(this), 111);//1100
        

        setTimeout(function(){
             this.multiplica()
        }.bind(this), 222);//1100
        

        // await this.multiplica()
        
        },


        async abrir_parcelas(ide,servico){
            
            // console.log(servico);
            // console.log('abrir_parcelas:');
            let tipo       = ''    
            let sqlservico = ''    
            if (servico>0){
                sqlservico = ' and CODIGO_SERVICO = '+servico
            }

            if (this.checkbox_so_entradas){
                tipo = ` tipo = 'E' and `
            }

            // let sql = 'select * from conta where  codigo_aluno = '+ide+ sqlservico+' order by TIPO, DATA_VENCIMENTO, codigo'
            let sql = `select * from conta where  ${tipo} ativo = 'S' and codigo_aluno = ${ide} ${sqlservico} order by TIPO, DATA_VENCIMENTO, codigo`
            // console.log(sql);
            await this.crud_abrir_tabela(sql, 'items_parcelas' )
            

            if (this.showJuros){
                await this.achar_atrasadas(this.items_parcelas)
            }


            //verifica se ja tem parcelas geradas..para mostrar ou nao alguns campos em gerar parcelas
            setTimeout(function(){
                this.primeira_parcela = this.items_parcelas.length<=0
                this.checkbox_entrada = this.primeira_parcela
                // this.primeira_parcela = true
                // console.log(this.primeira_parcela);
            }.bind(this), 555);//usar esse .bind(this) para chamar funcoes com o setTimeout 
            




            this.items_header = []//limpa
            this.items_header = [
                { text: 'CODIGO', value: 'CODIGO' },
                // { text: 'SEQ', value: 'SEQUENCIA' },
                { text: 'Visto', value: 'VISTO',},
                // { text: 'COBRAR_JUROS', value: 'COBRAR_JUROS',},

                { text: 'Tipo', value: 'TIPO', width:'100px'},
                { text: 'Conta Referente', value: 'CONTA_REFERENTE'},
                { text: 'SEQ', value: 'PLANO',},
                { text: '(=) Valor', value: 'double_VALOR', width:'120px'},
                { text: '(+) Juros', value: 'double_JUROS', width:'70px'},
                { text: '(-) Taxa', value: 'double_TAXA',width:'70px'},
                { text: '(=) Total', value: 'double_TOTAL',width:'120px'},

                { text: 'Vencimento', value: 'DATA_VENCIMENTO'},
                { text: 'Recebido', value: 'DATA_EFETUADO',width:'125px'},
                
                { text: '..', value: '..',width:'60px' },

                // { text: 'Forma', value: 'FORMA_PAGAMENTO', width:'130px'},
                // { text: 'Juros Texto', value: 'JUROS_MSG', width:'190px'},
                
                
                // { text: 'Pago', value: 'PAGO',width:'60px'},
                
                // { text: 'Categoria', value: 'CATEGORIA', width:'260px'},
                { text: 'Referente', value: 'SERVICO_REFERENTE', width:'590px'},//width:'260px'
                // { text: 'Anotação', value: 'OBSERVACAO', width:'260px'},
                // { text: 'Anotações', value: 'OBSERVACAO'},
                // { text: 'C.A', value: 'CODIGO_ALUNO' },
                // { text: 'C.S', value: 'CODIGO_SERVICO' },
                { text: 'Efetuou', value: 'QUEM_EFETUOU',width:'230px' },
                // { text: 'Quem Efetuou', value: 'QUEM_EFETUOU_CODIGO' },
                { text: 'Alterou', value: 'QUEM_ALTEROU',width:'230px' },

                { text: 'PIX ID', value: 'PIX_ID' },
                { text: 'PIX_GERADO', value: 'PIX_GERADO' },
                // { text: 'PIX_URL', value: 'PIX_URL' },
                // { text: 'double_TAXA', value: 'double_TAXA' },
                { text: '.', value: '.' },
                { text: 'DATA_EXCLUSAO', value: 'DATA_EXCLUSAO',width:'90px'},
                { text: 'DRE', value: 'VENDAS_DRE'},
            ]

                // removo os campos que nao quero visivel somente para edicao
                // if (this.souDSi == false){
                if (this.podeFaturar == false){

                    this.items_header.splice(this.items_header.findIndex(x => x.value === "PIX_ID") , 1);//removo a coluna senha
                    this.items_header.splice(this.items_header.findIndex(x => x.value === "PIX_GERADO") , 1);//removo a coluna senha
                    // this.items_header.splice(this.items_header.findIndex(x => x.value === "PIX_URL") , 1);//removo a coluna senha
                }

                // arrumar isso daqui em breve
                if (sessionStorage['conf_mostrar_juros'] != 'SIM'){
                    this.items_header.splice(this.items_header.findIndex(x => x.value === "double_VALOR") , 1);
                    this.items_header.splice(this.items_header.findIndex(x => x.value === "double_JUROS") , 1);
                    this.items_header.splice(this.items_header.findIndex(x => x.value === "double_TAXA") , 1);
                }

                // console.log('items_parcelas:')
                // console.log(this.items_parcelas);
        },


        async crud_empresa(){
           let r =  await DSisql.crud_empresa(this)
           return r
        },

    }

}
</script>

<style scoped>


@page:first {
   margin-top: 1cm !important;           
} 


  .container{
    max-width: 100%;
  }


.inline{
  display: inline  !important;
}

.cap{
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
}

.none{
  font-weight: normal;
  /* font-weight (bold, bolder, lighter, normal e 100-900 */
}

.h7{
  font-size: 9px !important;
}

.sem_borda{
     /* sem borda */
    border: none !important;
    box-shadow: none !important;
}



@media print {
  .no-print {
    display: none !important;
  }


  /* body {
    overflow: visible !important;
  } */

  .pagebreak {
     clear: both !important;
     page-break-after: always !important;
   }

  .container{
    max-width: 100%;
  }

  @page {
    margin-left: mm !important; /* Margem esquerda de 20mm */
    margin-right: 5mm !important; 
    /* margin-left: 2mm !important; Margem direita de 10mm */

    /* size: 80mm 120mm; /* 80mm de largura, altura automática */
    /* margin: 0mm; */ 
  }

}


/* @media print {
  body * {
    visibility: hidden;
    display: none; 
  }
  .no-print {
    display: none !important;
  }
  .print {
    visibility: visible;
    display: block; 
  }
} */

.theme--light.v-data-table tbody tr.v-data-table__selected {
    /* seleciona_linha cor */
    background: #eee9e9 !important;
}

.count_item {
  position: relative;
  top: 0px;
  font-size: 90%;
  vertical-align: super;
  color: red;
}


.fs-8{
    font-size: 8px !important;
  }
  .fs-10{
    font-size: 10px !important;
  }
  .fs-11{
    font-size: 11px !important;
  }
  .fs-12{
    font-size: 12px !important;
  }
  .fs-14{
    font-size: 14px !important;
  }
  .fs-16{
    font-size: 16px !important;
  }
  .fs-18{
    font-size: 18px !important;
  }



  .v-data-table >>> tr>td{
    font-size:12px !important;
    height: 25px !important;

  }

  
 
 
  /* padding das colunas data-table  */ 
 .v-data-table >>> td.text-start{
  padding-left: 3px !important;
  padding-right: 2px !important;
  /* padding: 0px 2px !important; */
  /* background-color: red !important; */
}
  
  /* padding dos titulos das colunas data-table */
  .v-data-table >>> th.text-start{
    padding: 0px 4px !important;
    /* background-color: red !important; */
    
  }


</style>
